/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa formsBIB
 *
 */
Intesa.FormsBIB = function () {
	
	this.score1 = "";
	
	var sessionScore1 = sessionStorage.getItem('score1') || '';
	if (sessionScore1.length > 0) {
		var JSON_score1 = JSON.parse(sessionScore1);
		this.score1 = JSON_score1;
	}

	function recaptchaCallback() {
		$("#recaptchainput").val('true');
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			formsBIB.checkPrivacy();
		}, 500);
	}

	function validationCallback() {
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			forms.checkPrivacy();
		}, 500);
	}

	var myForm = $('input[name="myForm"]').val();
	var isPBZ = $('html').attr('data-bank') == 'PBZ';
	var isCIB = $('html').attr('data-bank') == 'CIB';
	var isSLO = $('html').attr('data-bank') == 'ISPSLOVENIA';
	var isBIB = $('html').attr('data-bank') == 'BIB';
	
	var exchangeRate;

	/**
	 * Local variables
	 *
	 */
	var formsBIB = this;

	/**
	 * Init component
	 *
	 */
	this.init = function () {

		if (isCIB || isSLO || isPBZ) {
			window.intesa.formsBIB = null;
			return; 
		}

		window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? validationCallback : recaptchaCallback;

		formsBIB.sessionMortgage = [{
			"form1": {
				"propertyFound": "",
			}, "form2": {
				"propertyType": "",
				"pricePropertyOld": "",
				"pricePropertyNew": "",
				"areaPropertyNew": "",
				"householdMembers": "0",
				"downpaymentProperty": "",
				"propertySubject": "",
				"collateralProperties": "0",
				"mortgageBirthDate": "",
				"mortgageRepaymentMonths": "",
				"isFinancedPropertyCollateral": "",
			}, "form3": {
				"debtorPresence": "",
				"incomePersonal": "",
				"incomeCodebtor": "",
				"incomePersonalUnique": "",
				"creditCardPresence": "",
				"creditCardDebt": "",
				"codebtorCreditCardPresence": "",
				"codebtorCreditCardDebt": "",
			}, "summary": {
				"loanAmountSummary": "",
				"monthlyInstallmentDesired": "",
				"maxLoanAmount": "",
				"processingFee": "",
				"maxMonthlyInstallment": "",
				"vatRefund": "",
				"minValueCollateralForMaxLoanAmount": "",
				"totalExpensesBeforeLoan": "",
				"mass_uppermass": "",
				"isMagnifica": "",
				"cadastreFee": "",
				"cbReportFee": "",
				"estimationMarketValueRealEstate": "",
				"billsOfExchange": "",
				"notaryFeeandCostsNotarization": "",
				"annualPremiumInsurance": "",
				"cadastreFeeMortgageRegistration": "",
				"rewardAndCostsNotaries": "",
				"productId": "",
				"productName": "",
				"countryPrefix": "381"
			},
			"score": "",
			"typeOfAppointment": "",
		}];

		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);
			formsBIB.sessionMortgage = JSON_Obj;
		}

		if($('[data-component-r="formMortgageSummaryComponent"]').length > 0 && sessionJSON.length > 0){			// && sessionJSON.length > 0
			formsBIB.getJsonAjax();
			formsBIB.initAndUpdateSummary();
		}
		
		formsBIB.setProductName();
		
		formsBIB.setMagnificaCss();		// SET MAGNIFICA CSS
		
		if($('[name="linkDefaultMagnificaMortgage"]').length > 0){
			
			formsBIB.setStartingPage();
			
		}

		if ($('[data-component-r="formStep1Mortagage"]').length > 0 || $('[data-component-r="formStep2Mortagage"]').length > 0 || $('[data-component-r="formStep3Mortagage"]').length > 0 || $('[data-component-r="survey_loan"]').length > 0) {
			formsBIB.refreshStep(1);
			formsBIB.toggleAccordion();
			formsBIB.formStep1Mortagage();
			if (sessionStorage.getItem('back') != 'true') {
				$('.rstep1').removeClass('rhide');
			}
			formsBIB.setActiveInput();
			formsBIB.setActiveImport();
			//formsBIB.stepByStorage();
			formsBIB.goToNext();
			formsBIB.goBackStep();
			formsBIB.plusMinus();
			if ($("#privacystatus").length > 0) {
				formsBIB.checkPrivacy();
			}
			formsBIB.initStep();
			formsBIB.writeInput();
			
			// formsBIB.checkMobileOrDesktopQuestionOne();
		}
		
		if($('[name="downpaymentProperty"]').length > 0){
			formsBIB.setAndCheckDownPayment();
		}
		if($('[name="mortgageBirthDate"]').length > 0){
			formsBIB.setAndCheckBirthDate();
		}
		if($('[name="mortgageRepaymentMonths"]').length > 0){
			formsBIB.setAndCheckRepaymentMonths(false);
		}

	};

	
	/* --------------------- */
	
	/* DA NON METTERE
	this.totalExpensesButton = function() {
		$(".button-total-expense").on("click", function (){
		    if($('.total-expenses-summary-mortgage').hasClass("mortgage-hide-summary")){
		        $('.total-expenses-summary-mortgage').removeClass("mortgage-hide-summary");
		    }
		    else{
		        $('.total-expenses-summary-mortgage').addClass("mortgage-hide-summary");
		    }
		})
	}
	*/
	
	
	
	// SET MAGNIFICA CSS
	this.setMagnificaCss = function() {

		var thisPageLink = window.location.pathname;
		
		if(thisPageLink.toLowerCase().includes("magnifica")){
	    	// var magnificaCss = $(".mortgageContainerPage").attr("data-magnifica-css");
	    	// $('[rel="preload stylesheet"][as="font"]').attr("href", magnificaCss);
	    	
	    	$(".r-btn-nextMortgage").each(function () {
				$(this).addClass("nextButtonMagnifica");
			})
			
			$(".r-progress-bar-fillMortgage").each(function () {
				$(this).addClass("r-progress-bar-fill-magnifica");
			})
			
			$(".rtitle-accordotionMortgage").each(function () {
				$(this).addClass("rtitle-accordotion-magnifica");
			})
			
			$(".buttonPlusMinusMortgage").each(function () {
				$(this).addClass("plusMinusButtonMagnifica");
			})
			
			$(".loanCalculator__close_mortgage").each(function () {
				$(this).addClass("loanCalculator__close_mortgage_magnifica");
			})
	    	
	    }
	}
	
	
	
	// FUNZIONE RATA EXCEL
	this.pmtFunctionRate = function(rate, nperiod, pv, fv, type) {
	    if (!fv) fv = 0;
	    if (!type) type = 0;
	    if (rate == 0) return -(pv + fv)/nperiod;
	    var pvif = Math.pow(1 + rate, nperiod);
	    var pmt = rate / (pvif - 1) * -(pv * pvif + fv);
	    if (type == 1) {
	        pmt /= (1 + rate);
	    };
	    return pmt;
	}
	
	
	// FUNZIONE VA EXCEL
	this.pvFunction = function (rate, num, amount, remain, type) {
		if (!remain) remain = 0;
	    if (!type) type = 0;
		if (type == 0) {
			var factor = (rate == 0 ? num : (1 - Math.pow(1+rate, -num))/rate);
			return -amount*factor - remain * Math.pow(1+rate, -num);
		}
		else {
			var factor = (rate == 0 ? num : (1 - Math.pow(1+rate, -num))*(1+rate)/rate);
			return -amount*factor - remain * Math.pow(1+rate, -num);
		}
	}
	
	
	this.getJsonAjax = function() {
		var endpoint = window.location.origin + '/digitalServicesServlet/?operation=getExchangeRates&httpMethod=GET&endpointName=getExchangeRates&listType=BIB_DEV&headers=standardHeaders&bank=BIB&bankId=BIB&locale=sr';
		middleExchangeRateActive = $.ajax({
                method: "GET",
                async: false,
                url: endpoint
            })
            .done(function(data) {
                if (data != null) {
                	formsBIB.exchangeRate = formsBIB.setUniversalMiddleExchangeRates(JSON.parse(JSON.stringify(data)));
                }
            })
    }
	
	 this.setUniversalMiddleExchangeRates = function(json) {
		 var middleExchangeRateActive;
		 var middleExchangeRate;
		 var newMiddleExchangeRate;
		 $.each(json.rates, function(key, value) {
            var jsonValue = value;
            var toCurrency = jsonValue.toCurrency.label;
            if (toCurrency == 'EUR') {
                middleExchangeRate = number_format(jsonValue.meanRate.rate, 2, ".", " ");
                newMiddleExchangeRate = number_format(jsonValue.meanRate.rate, 2, ".", " ");
                middleExchangeRateActive = number_format(jsonValue.meanRate.rate, 2, ".", " ");
            }
		 });
		 return middleExchangeRateActive;
    }
	
	
	this.initAndUpdateSummary = function(){
		var stringToGoIntoTheRegex = "\\B(?=(\\d{3})+(?!\\d))";
		var regexNumbers = new RegExp(stringToGoIntoTheRegex, "g");
		
		var mortgageJson = formsBIB.sessionMortgage[0];
		var newPropertyValue = mortgageJson['form2']['pricePropertyNew'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		var oldPropertyValue = mortgageJson['form2']['pricePropertyOld'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		var propertyValue;
		if(oldPropertyValue.length > 0 && (newPropertyValue == null || newPropertyValue == undefined || newPropertyValue == "" || newPropertyValue.lenght == 0)){
			$('[name="{vatRefund}"]').addClass("mortgage-hide-summary");
			propertyValue = parseFloat(oldPropertyValue);
		}
		else{
			propertyValue = parseFloat(newPropertyValue);
		}
		var stringValues = $("[name=summaryMortgageJsonValues]").attr("data-mortgage-summary-json-values");
		var jsonObject = JSON.parse(stringValues);
		var jsonValues = jsonObject['values'];
		var jsonNotaryFee = jsonObject['notaryFee'];
		var jsonCadastralTariff = jsonObject['cadastralTariff'];
		var jsonTotalNotaryCost = jsonObject['totalNotaryCost'];
		var jsonResultsSection = jsonObject['resultsSection'];
		
		
		// LOAN AMOUNT
		var downpayment = parseFloat(mortgageJson['form2']['downpaymentProperty'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' ));
		var loanAmount = propertyValue - downpayment;						// B39 = B26 - B27
		var loanAmount_toShow = (Math.floor((Math.pow(10, 2)*loanAmount)+0.5)*Math.pow(10, -2)).toFixed(2);
		//var loanAmountContent = $("[name='{loanAmount}']").html();
		//loanAmountContent = loanAmountContent.replace("{loanAmount}", loanAmount_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{loanAmount}']").html(loanAmountContent);
		$("[data-output-summary='{loanAmount}']").html(loanAmount_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		
		// MONTHLY INSTALLMENT DESIRED
		var margin360Mass = jsonValues['margin360Mass'];					// B8
		var margin360Uppermass = jsonValues['margin360Uppermass'];			// B9
		var margin360Magnifica = jsonValues['margin360Magnifica'];			// B10
		var margin180Mass = jsonValues['margin180Mass'];					// B11
		var margin180Uppermass = jsonValues['margin180Uppermass'];			// B12
		var margin180Magnifica = jsonValues['margin180Magnifica'];			// B13
		var tenor; 															// B32
		tenor = parseFloat(mortgageJson['form2']['mortgageRepaymentMonths'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' ));
		var monthlyIncome;													// B33
		var monthlyIncomeCodebtor;	
		var incomePersonal = mortgageJson['form3']['incomePersonal'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		var incomeCodebtor = mortgageJson['form3']['incomeCodebtor'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		var incomePersonalUnique = mortgageJson['form3']['incomePersonalUnique'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		if(incomePersonalUnique.length > 0){
			monthlyIncome = parseFloat(incomePersonalUnique);
		}
		else{
			monthlyIncome = parseFloat(incomePersonal);						// + parseFloat(incomeCodebtor);
			monthlyIncomeCodebtor = parseFloat(incomeCodebtor);
		}
		var banksMargin;													// L38
		if(tenor < 181){
			if(monthlyIncome < 700){
				banksMargin = margin180Mass;
			}
			else{
				if(monthlyIncome < 1500){
					banksMargin = margin180Uppermass;
				}else{
					banksMargin = margin180Magnifica;
				}
			}
		}else{
			if(monthlyIncome < 700){
				banksMargin = margin360Mass;
			}else{
				if(monthlyIncome < 1500){
					banksMargin = margin360Uppermass;
				}else{
					banksMargin = margin360Magnifica;
				}
			}
		}
		var value3mEuribor = jsonValues['value3mEuribor'];					// B5
		var nominalInterestRate = banksMargin + value3mEuribor;				// L39
		nominalInterestRate = (Math.floor((Math.pow(10, 2)*nominalInterestRate)+0.5)*Math.pow(10, -2)).toFixed(2);
		var nominalInterestRate_forPmt = (nominalInterestRate/100)/360*30.5;
		var pmt = parseFloat(formsBIB.pmtFunctionRate(nominalInterestRate_forPmt, tenor, -loanAmount));
		var monthlyInstallmentDesired = (Math.floor((Math.pow(10, 2)*pmt)+0.5)*Math.pow(10, -2)).toFixed(2);
		var monthlyInstallmentDesiredContent = $("#headerMonthlyInstallDesiredSummary").html();
		monthlyInstallmentDesiredContent = monthlyInstallmentDesiredContent.replace("{value}", monthlyInstallmentDesired.toString().replace(".", ",").replace(regexNumbers, "."));
		$("#headerMonthlyInstallDesiredSummary").html(monthlyInstallmentDesiredContent);
		$("[data-algorithm-output='monthlyInstallDesiredSummary']").html(monthlyInstallmentDesired.toString().replace(".", ",").replace(regexNumbers, "."));
		
		
		// MAXLOANAMOUNT
		var isFinancedPropertyCollateral = mortgageJson['form2']['isFinancedPropertyCollateral'];	// B36
		var LTVmaxLoanAmount;														// L41 
		if(isFinancedPropertyCollateral == "Yes"){
			LTVmaxLoanAmount = propertyValue/1.25;
		}else{
			LTVmaxLoanAmount = propertyValue/1.11111111;
		}
		var kCoeffVariableInterest = jsonValues['kCoeffVariableInterest'];			// B14
		var fxCoeff = jsonValues['fxCoeff'];										// B16
		var coeffNetMonthlyIncome1 = jsonValues['coeffNetMonthlyIncome1'];			// B17
		var coeffNetMonthlyIncome2 = jsonValues['coeffNetMonthlyIncome2'];			// B18

		var exchangeRateNbs;
		if(formsBIB.exchangeRate == null || formsBIB.exchangeRate == undefined || formsBIB.exchangeRate == ""){
			exchangeRateNbs = jsonValues['exchangeRateNbs'];						// B6			
		}
		else{
			exchangeRateNbs = formsBIB.exchangeRate;	// parseFloat("118.00");	// SET a 118.00 per TEST				
		}
		
		console.log("Today Exchange Rate: ", exchangeRateNbs);
		
		var customerBasket = jsonValues['customerBasket'];							// B7
		var customerBasketEUR = customerBasket/exchangeRateNbs;						// L31
		var sumOfMonthlyObligations = 0;											// B35
		var creditCardDebt = mortgageJson['form3']['creditCardDebt'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		var codebtorCreditCardDebt = mortgageJson['form3']['codebtorCreditCardDebt'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );
		
		var ATPmaxLoanInstallmentClient = 0;
		var ATPmaxLoanInstallmentCodebtor = 0;
		var sumOfMonthlyObligationsClient;
		var sumOfMonthlyObligationsCodebtor;
		var ATPmaxLoanInstallment;													// L43
		if(creditCardDebt.length > 0){
			sumOfMonthlyObligationsClient = parseFloat(sumOfMonthlyObligations) + parseFloat(creditCardDebt);
		}
		else{
			sumOfMonthlyObligationsClient = parseFloat(sumOfMonthlyObligations);
		}
		ATPmaxLoanInstallmentClient = Math.min(kCoeffVariableInterest*fxCoeff*coeffNetMonthlyIncome1*(monthlyIncome-customerBasketEUR)-sumOfMonthlyObligationsClient, kCoeffVariableInterest*fxCoeff*(monthlyIncome*coeffNetMonthlyIncome2)-sumOfMonthlyObligationsClient);
		if(!(incomePersonalUnique.length > 0)){
			if(codebtorCreditCardDebt.length > 0){
				sumOfMonthlyObligationsCodebtor = parseFloat(sumOfMonthlyObligations) + parseFloat(codebtorCreditCardDebt);
			}
			else{
				sumOfMonthlyObligationsCodebtor = parseFloat(sumOfMonthlyObligations);
			}
			ATPmaxLoanInstallmentCodebtor = Math.min(kCoeffVariableInterest*fxCoeff*coeffNetMonthlyIncome1*(monthlyIncomeCodebtor-customerBasketEUR)-sumOfMonthlyObligationsCodebtor, kCoeffVariableInterest*fxCoeff*(monthlyIncomeCodebtor*coeffNetMonthlyIncome2)-sumOfMonthlyObligationsCodebtor);
		}
		ATPmaxLoanInstallment = ATPmaxLoanInstallmentClient + ATPmaxLoanInstallmentCodebtor;								// L43
		var nominalInterestRate_forPv = (nominalInterestRate/100)/360*30.501;
		var ATPmaxLoanAmount = parseFloat(formsBIB.pvFunction(nominalInterestRate_forPv, tenor, -ATPmaxLoanInstallment));	// L44
		var maxLoanAmount = Math.min(LTVmaxLoanAmount, ATPmaxLoanAmount);			// B43
		var maxLoanAmount_toShow = (Math.floor((Math.pow(10, 2)*maxLoanAmount)+0.5)*Math.pow(10, -2)).toFixed(2);
		//var maxLoanAmountContent = $("[name='{maxLoan}']").html();
		//maxLoanAmountContent = maxLoanAmountContent.replace("{maxLoan}", maxLoanAmount_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{maxLoan}']").html(maxLoanAmountContent);
		$("[data-output-summary='{maxLoan}']").html(maxLoanAmount_toShow.toString().replace(".", ",").replace(regexNumbers, "."));

		
		// PROCESSING FEE
		var loanProcessingFeeMass = jsonValues['loanProcessingFeeMass'];			// B19
		var loanProcessingFeeUppermass = jsonValues['loanProcessingFeeUppermass'];	// B20
		var loanProcessingFeeMagnifica = jsonValues['loanProcessingFeeMagnifica'];	// B21
		var processingFee;
		if(monthlyIncome < 700){
			processingFee = maxLoanAmount*loanProcessingFeeMass;
		}else{
			if(monthlyIncome < 1500){
				processingFee = maxLoanAmount*loanProcessingFeeUppermass;
			}else{
				processingFee = maxLoanAmount*loanProcessingFeeMagnifica;
			}
		}
		var processingFee_toShow = (Math.floor((Math.pow(10, 2)*processingFee)+0.5)*Math.pow(10, -2)).toFixed(2);
		//var processingFeeContent = $("[name='{processingFee}']").html();
		//processingFeeContent = processingFeeContent.replace("{processingFee}", processingFee_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{processingFee}']").html(processingFeeContent);
		$("[data-output-summary='{processingFee}']").html(processingFee_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		
		// MAXIMUM MONTHLY INSTALLMENT
		var LTVmaxLoanInstallment = parseFloat(formsBIB.pmtFunctionRate(nominalInterestRate_forPmt, tenor, -LTVmaxLoanAmount));	// L42	
		LTVmaxLoanInstallment = (Math.floor((Math.pow(10, 2)*LTVmaxLoanInstallment)+0.5)*Math.pow(10, -2)).toFixed(2);	
		var maxMonthlyInstallment = Math.min(LTVmaxLoanInstallment, ATPmaxLoanInstallment);
		var maxMonthlyInstallment_toShow = (Math.floor((Math.pow(10, 2)*maxMonthlyInstallment)+0.5)*Math.pow(10, -2)).toFixed(2);
		//var maxMonthlyInstallmentContent = $("[name='{maxInstallment}']").html();
		//maxMonthlyInstallmentContent = maxMonthlyInstallmentContent.replace("{maxInstallment}", maxMonthlyInstallment_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{maxInstallment}']").html(maxMonthlyInstallmentContent);
		$("[data-output-summary='{maxInstallment}']").html(maxMonthlyInstallment_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		
		// VAT REFUND oldPropertyValue
		var vatRefund_toShow = "/";
		if(newPropertyValue.length > 0 && (oldPropertyValue == null || oldPropertyValue == undefined || oldPropertyValue == "" || oldPropertyValue.lenght == 0)){
			var areaPropertyNew = parseFloat(mortgageJson['form2']['areaPropertyNew'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' ));	// B28
			var householdMembers = mortgageJson['form2']['householdMembers'].replace(/\s/g, '' ).replace(/\s/g, '' ).replace( /\,/g, '' ).replace( /\./g, '' );				// B29
			var areaKVMentitledRefund;															// L55
			if(areaPropertyNew <= 40){
				areaKVMentitledRefund = areaPropertyNew;
			}else{
				areaKVMentitledRefund = 40;
			}
			
			var areaKVMhouseholdEntitledRefund;													// L56
			if(householdMembers == "0"){
				areaKVMhouseholdEntitledRefund = 0;
			}else if(householdMembers == "1"){
				areaKVMhouseholdEntitledRefund = 15;
			}else if(householdMembers == "2"){
				areaKVMhouseholdEntitledRefund = 30;
			}else if(householdMembers == "3"){
				areaKVMhouseholdEntitledRefund = 45;
			}else if(householdMembers == "4"){
				areaKVMhouseholdEntitledRefund = 60;
			}else if(householdMembers == "5"){
				areaKVMhouseholdEntitledRefund = 75;
			}else if(householdMembers == "6"){
				areaKVMhouseholdEntitledRefund = 90;
			}else if(householdMembers == "7"){
				areaKVMhouseholdEntitledRefund = 105;
			}else if(householdMembers == "8"){
				areaKVMhouseholdEntitledRefund = 120;
			}else if(householdMembers == "9"){
				areaKVMhouseholdEntitledRefund = 135;
			}else if(householdMembers == "10"){
				areaKVMhouseholdEntitledRefund = 150;
			}
			
			var totalAreaKVMrightRefund;														// L57 
			if(areaKVMentitledRefund + areaKVMhouseholdEntitledRefund > areaPropertyNew){
				totalAreaKVMrightRefund = areaPropertyNew;
			}else{
				totalAreaKVMrightRefund = areaKVMentitledRefund + areaKVMhouseholdEntitledRefund;
			}
			
			var pricePropertyPerM2 = propertyValue/areaPropertyNew;								// L58
			var vatRate = jsonValues['vatRate'];												// B22
			var vatRefund = pricePropertyPerM2*totalAreaKVMrightRefund*(vatRate/100);
			vatRefund_toShow = (Math.floor((Math.pow(10, 2)*vatRefund)+0.5)*Math.pow(10, -2)).toFixed(2);
			//var vatRefundContent = $("[name='{vatRefund}']").html();
			//vatRefundContent = vatRefundContent.replace("{vatRefund}", vatRefund_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
			//$("[name='{vatRefund}']").html(vatRefundContent);
			$("[data-output-summary='{vatRefund}']").html(vatRefund_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		}
		

		// MINIMAL VALUE OF OTHER COLLATERAL FOR THE MAXIMUM LOAN AMOUNT
		var minValueCollateralForMaxLoanAmount_toShow = "/";
		if(isFinancedPropertyCollateral == "Yes"){
			$('[name="{minValueCollateral}"]').addClass("mortgage-hide-summary");
		}
		else{
			var minValueCollateralForMaxLoanAmount = maxLoanAmount*1.25;
			minValueCollateralForMaxLoanAmount_toShow = (Math.floor((Math.pow(10, 2)*minValueCollateralForMaxLoanAmount)+0.5)*Math.pow(10, -2)).toFixed(2);
			//var minValueCollateralForMaxLoanAmountContent = $("[name='{minValueCollateral}']").html();
			//minValueCollateralForMaxLoanAmountContent = minValueCollateralForMaxLoanAmountContent.replace("{minValueCollateral}", minValueCollateralForMaxLoanAmount_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
			//$("[name='{minValueCollateral}']").html(minValueCollateralForMaxLoanAmountContent);
			$("[data-output-summary='{minValueCollateral}']").html(minValueCollateralForMaxLoanAmount_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		}
		
		
		// Total expenses before loan disbursement based on the maximum loan amount	
		var propertyPriceWithVatRSD = propertyValue*exchangeRateNbs;							// L48
		var maxLoanAmountRSD = maxLoanAmount*exchangeRateNbs;									// L49
		var totalNotaryCostValue = parseFloat(jsonTotalNotaryCost['totalNotaryCostValue']);		// J16
		var notaryRewardCoeff = parseFloat(jsonNotaryFee['notaryRewardCoeff']);
		var notaryRewardPercentage = parseFloat(jsonNotaryFee['notaryRewardPercentage'])/100;
		var totalFees_property = 0;																// K29
		var totalFees = 0;																		// L29	
		var maxLimitLegalWorkValue = parseFloat(jsonNotaryFee['maxLimitLegalWorkValue']);		// E17
		var maxPoints = parseFloat(jsonNotaryFee['legalWorkValue6Points']);
		
		var valueLegalWorknogPosla;																// L26
		if(maxLoanAmountRSD < maxLimitLegalWorkValue){
			valueLegalWorknogPosla = "Manje od 14 mil. RSD";
		}else{
			valueLegalWorknogPosla = maxLoanAmountRSD;
		}
		
		var additionalPoints;																	// L27
		try {
			if(Math.ceil((valueLegalWorknogPosla - maxLimitLegalWorkValue)/1000000)*10 < 0){
				additionalPoints = 0;
			} else{
				additionalPoints = Math.ceil((valueLegalWorknogPosla - maxLimitLegalWorkValue)/1000000)*10;
			}
		}
		catch(err) {
			additionalPoints = "Nema";
		}
		
		var limitTotalNumberOfPoints = parseFloat(jsonNotaryFee['limitTotalNumberOfPoints']);
		var totalNumberOfPoints;																// L28
		try {
			if((additionalPoints + maxPoints) > limitTotalNumberOfPoints){
				totalNumberOfPoints = limitTotalNumberOfPoints;
			}else{
				totalNumberOfPoints = additionalPoints + maxPoints;
			}
		}
		catch(err) {
			totalNumberOfPoints = "";
		}
		
		if(additionalPoints.toString() != "Nema"){
			if(totalNumberOfPoints > limitTotalNumberOfPoints){
				totalFees = limitTotalNumberOfPoints*notaryRewardCoeff*notaryRewardPercentage;
			}
			else{
				totalFees = totalNumberOfPoints*notaryRewardCoeff*notaryRewardPercentage;
			}
		}
		
		var notaryRewardPoint;
		var notaryRewardValue;
		
		if(maxLoanAmountRSD > 1 && maxLoanAmountRSD <= 600000){
			notaryRewardPoint = parseFloat(jsonNotaryFee['legalWorkValue1Points']);
			notaryRewardValue = notaryRewardPoint * notaryRewardCoeff * notaryRewardPercentage;
			rewardAndNotaryCostsInRSD = notaryRewardValue + totalNotaryCostValue;
		}else if(maxLoanAmountRSD > 600000 && maxLoanAmountRSD <= 2500000){
			notaryRewardPoint = parseFloat(jsonNotaryFee['legalWorkValue2Points']);
			notaryRewardValue = notaryRewardPoint * notaryRewardCoeff * notaryRewardPercentage;
			rewardAndNotaryCostsInRSD = notaryRewardValue + totalNotaryCostValue;
		}else if(maxLoanAmountRSD > 2500000 && maxLoanAmountRSD <= 5000000){
			notaryRewardPoint = parseFloat(jsonNotaryFee['legalWorkValue3Points']);
			notaryRewardValue = notaryRewardPoint * notaryRewardCoeff * notaryRewardPercentage;
			rewardAndNotaryCostsInRSD = notaryRewardValue + totalNotaryCostValue;
		}else if(maxLoanAmountRSD > 5000000 && maxLoanAmountRSD <= 7000000){
			notaryRewardPoint = parseFloat(jsonNotaryFee['legalWorkValue4Points']);
			notaryRewardValue = notaryRewardPoint * notaryRewardCoeff * notaryRewardPercentage;
			rewardAndNotaryCostsInRSD = notaryRewardValue + totalNotaryCostValue;
		}else if(maxLoanAmountRSD > 7000000 && maxLoanAmountRSD <= 10000000){
			notaryRewardPoint = parseFloat(jsonNotaryFee['legalWorkValue5Points']);
			notaryRewardValue = notaryRewardPoint * notaryRewardCoeff * notaryRewardPercentage;
			rewardAndNotaryCostsInRSD = notaryRewardValue + totalNotaryCostValue;
		}else if(maxLoanAmountRSD > 10000000 && maxLoanAmountRSD <= 14000000){
			notaryRewardPoint = parseFloat(jsonNotaryFee['legalWorkValue6Points']);
			notaryRewardValue = notaryRewardPoint * notaryRewardCoeff * notaryRewardPercentage;
			rewardAndNotaryCostsInRSD = notaryRewardValue + totalNotaryCostValue;
		}else if(maxLoanAmountRSD == 0){
			rewardAndNotaryCostsInRSD = 0;
		}
		else{
			rewardAndNotaryCostsInRSD = totalFees + totalNotaryCostValue;
		}
		
		if(additionalPoints.toString() == "Nema"){
			totalFees = rewardAndNotaryCostsInRSD;
		}
		
		var republicAdministrativeFee = parseFloat(jsonCadastralTariff['republicAdministrativeFee']);				// J11
		var cadestreFeeVariableRSD;
		if(maxLoanAmountRSD <= 6000000){
			cadestreFeeVariableRSD = parseFloat(jsonCadastralTariff['cadastralTariff1Fee']);						// J6
		}else if(maxLoanAmountRSD > 6000000 && maxLoanAmountRSD <= 30000000){
			cadestreFeeVariableRSD = parseFloat(jsonCadastralTariff['cadastralTariff2Fee']);						// J7
		}else if(maxLoanAmountRSD > 30000000 && maxLoanAmountRSD <= 60000000){
			cadestreFeeVariableRSD = parseFloat(jsonCadastralTariff['cadastralTariff3Fee']);						// J8
		}else if(maxLoanAmountRSD > 60000000){
			cadestreFeeVariableRSD = parseFloat(jsonCadastralTariff['cadastralTariff4Fee']);						// J9
		}
		var cadastreFeeMortgageRegistrationRSD = cadestreFeeVariableRSD + republicAdministrativeFee;				// L51

		var valueLegalWorknogPosla_property;																		// K26
		if(propertyPriceWithVatRSD < maxLimitLegalWorkValue){
			valueLegalWorknogPosla_property = "Manje od 14 mil. RSD";
		}else{
			valueLegalWorknogPosla_property = propertyPriceWithVatRSD;
		}
		
		var additionalPoints_property;																				// K27
		try {
			if(Math.ceil((valueLegalWorknogPosla_property - maxLimitLegalWorkValue)/1000000)*10 < 0){
				additionalPoints_property = 0;
			} else{
				additionalPoints_property = Math.ceil((valueLegalWorknogPosla_property - maxLimitLegalWorkValue)/1000000)*10;
			}
		}
		catch(err) {
			additionalPoints_property = "Nema";
		}
		
		var totalNumberOfPoints_property;																			// K28
		try {
			if((additionalPoints_property + maxPoints) > limitTotalNumberOfPoints){
				totalNumberOfPoints_property = limitTotalNumberOfPoints;
			}else{
				totalNumberOfPoints_property = additionalPoints_property + maxPoints;
			}
		}
		catch(err) {
			totalNumberOfPoints_property = "";
		}
		
		if(additionalPoints_property.toString() != "Nema"){
			if(totalNumberOfPoints_property > limitTotalNumberOfPoints){
				totalFees_property = limitTotalNumberOfPoints*notaryRewardCoeff;
			}
			else{
				totalFees_property = totalNumberOfPoints_property*notaryRewardCoeff;
			}
		}
		
		var notaryRewardPoint_property;
		var notaryRewardValue_property;
		
		var rewardNotaryCostsCertificationContractRSD;																// L52
		if(propertyPriceWithVatRSD > 1 && propertyPriceWithVatRSD <= 600000){
			notaryRewardPoint_property = parseFloat(jsonNotaryFee['legalWorkValue1Points']);
			notaryRewardValue_property = notaryRewardPoint_property * notaryRewardCoeff;
			rewardNotaryCostsCertificationContractRSD = notaryRewardValue_property + totalNotaryCostValue;
		}else if(propertyPriceWithVatRSD > 600000 && propertyPriceWithVatRSD <= 2500000){
			notaryRewardPoint_property = parseFloat(jsonNotaryFee['legalWorkValue2Points']);
			notaryRewardValue_property = notaryRewardPoint_property * notaryRewardCoeff;
			rewardNotaryCostsCertificationContractRSD = notaryRewardValue_property + totalNotaryCostValue;
		}else if(propertyPriceWithVatRSD > 2500000 && propertyPriceWithVatRSD <= 5000000){
			notaryRewardPoint_property = parseFloat(jsonNotaryFee['legalWorkValue3Points']);
			notaryRewardValue_property = notaryRewardPoint_property * notaryRewardCoeff;
			rewardNotaryCostsCertificationContractRSD = notaryRewardValue_property + totalNotaryCostValue;
		}else if(propertyPriceWithVatRSD > 5000000 && propertyPriceWithVatRSD <= 7000000){
			notaryRewardPoint_property = parseFloat(jsonNotaryFee['legalWorkValue4Points']);
			notaryRewardValue_property = notaryRewardPoint_property * notaryRewardCoeff;
			rewardNotaryCostsCertificationContractRSD = notaryRewardValue_property + totalNotaryCostValue;
		}else if(propertyPriceWithVatRSD > 7000000 && propertyPriceWithVatRSD <= 10000000){
			notaryRewardPoint_property = parseFloat(jsonNotaryFee['legalWorkValue5Points']);
			notaryRewardValue_property = notaryRewardPoint_property * notaryRewardCoeff;
			rewardNotaryCostsCertificationContractRSD = notaryRewardValue_property + totalNotaryCostValue;
		}else if(propertyPriceWithVatRSD > 10000000 && propertyPriceWithVatRSD <= 14000000){
			notaryRewardPoint_property = parseFloat(jsonNotaryFee['legalWorkValue6Points']);
			notaryRewardValue_property = notaryRewardPoint_property * notaryRewardCoeff;
			rewardNotaryCostsCertificationContractRSD = notaryRewardValue_property + totalNotaryCostValue;
		}else if(propertyPriceWithVatRSD == 0){
			rewardNotaryCostsCertificationContractRSD = 0;
		}
		else{
			rewardNotaryCostsCertificationContractRSD = totalFees_property + totalNotaryCostValue;
		}
		
		if(additionalPoints_property.toString() == "Nema"){
			totalFees_property= rewardNotaryCostsCertificationContractRSD;
		}
		
		var cadastreFee = parseFloat(jsonResultsSection['cadastreFee']) / exchangeRateNbs;												// B48
		var cbReportFee = parseFloat(jsonResultsSection['cbReportFee']) / exchangeRateNbs;												// B49
		var coeffEstimationMarketValueRealEstate = parseFloat(jsonResultsSection['coeffEstimationMarketValueRealEstate']);
		var estimationMarketValueRealEstate = (coeffEstimationMarketValueRealEstate * exchangeRateNbs) / exchangeRateNbs; 				// B50
		var billsOfExchange = parseFloat(jsonResultsSection['billsOfExchange']) / exchangeRateNbs; 										// B51
		var notaryFeeandCostsNotarization = rewardAndNotaryCostsInRSD / exchangeRateNbs;												// B52
		var coeffAnnualPremiumInsurance = parseFloat(jsonResultsSection['coeffAnnualPremiumInsurance']);
		var annualPremiumInsurance = (coeffAnnualPremiumInsurance * exchangeRateNbs) / exchangeRateNbs;									// B53
		var cadastreFeeMortgageRegistration = cadastreFeeMortgageRegistrationRSD / exchangeRateNbs; 									// B54
		var rewardAndCostsNotaries = rewardNotaryCostsCertificationContractRSD / exchangeRateNbs;										// B55
		var totalExpensesBeforeLoan = cadastreFee + cbReportFee + estimationMarketValueRealEstate + billsOfExchange + notaryFeeandCostsNotarization + annualPremiumInsurance + cadastreFeeMortgageRegistration + rewardAndCostsNotaries;
		
		var cadastreFee_toShow = (Math.floor((Math.pow(10, 2)*cadastreFee)+0.5)*Math.pow(10, -2)).toFixed(2);
		var cbReportFee_toShow = (Math.floor((Math.pow(10, 2)*cbReportFee)+0.5)*Math.pow(10, -2)).toFixed(2);
		var estimationMarketValueRealEstate_toShow = (Math.floor((Math.pow(10, 2)*estimationMarketValueRealEstate)+0.5)*Math.pow(10, -2)).toFixed(2);
		var billsOfExchange_toShow = (Math.floor((Math.pow(10, 2)*billsOfExchange)+0.5)*Math.pow(10, -2)).toFixed(2);
		var notaryFeeandCostsNotarization_toShow = (Math.floor((Math.pow(10, 2)*notaryFeeandCostsNotarization)+0.5)*Math.pow(10, -2)).toFixed(2);
		var annualPremiumInsurance_toShow = (Math.floor((Math.pow(10, 2)*annualPremiumInsurance)+0.5)*Math.pow(10, -2)).toFixed(2);
		var cadastreFeeMortgageRegistration_toShow = (Math.floor((Math.pow(10, 2)*cadastreFeeMortgageRegistration)+0.5)*Math.pow(10, -2)).toFixed(2);
		var rewardAndCostsNotaries_toShow = (Math.floor((Math.pow(10, 2)*rewardAndCostsNotaries)+0.5)*Math.pow(10, -2)).toFixed(2);
		var totalExpensesBeforeLoan_toShow = (Math.floor((Math.pow(10, 2)*totalExpensesBeforeLoan)+0.5)*Math.pow(10, -2)).toFixed(2);
		
		// 1
		//var cadastreFeeContent = $("[name='{cadastreFee}']").html();
		//cadastreFeeContent = cadastreFeeContent.replace("{cadastreFee}", cadastreFee_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{cadastreFee}']").html(cadastreFeeContent);
		$("[data-output-summary='{cadastreFee}']").html(cadastreFee_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 2
		//var cbReportFeeContent = $("[name='{cbReportFee}']").html();
		//cbReportFeeContent = cbReportFeeContent.replace("{cbReportFee}", cbReportFee_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{cbReportFee}']").html(cbReportFeeContent);
		$("[data-output-summary='{cbReportFee}']").html(cbReportFee_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 3
		//var estimationMarketValueRealEstateContent = $("[name='{estimationMarketValueRealEstate}']").html();
		//estimationMarketValueRealEstateContent = estimationMarketValueRealEstateContent.replace("{estimationMarketValueRealEstate}", estimationMarketValueRealEstate_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{estimationMarketValueRealEstate}']").html(estimationMarketValueRealEstateContent);
		$("[data-output-summary='{estimationMarketValueRealEstate}']").html(estimationMarketValueRealEstate_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 4
		//var billsOfExchangeContent = $("[name='{billsOfExchange}']").html();
		//billsOfExchangeContent = billsOfExchangeContent.replace("{billsOfExchange}", billsOfExchange_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{billsOfExchange}']").html(billsOfExchangeContent);
		$("[data-output-summary='{billsOfExchange}']").html(billsOfExchange_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 5
		//var notaryFeeandCostsNotarizationContent = $("[name='{notaryFeeandCostsNotarization}']").html();
		//notaryFeeandCostsNotarizationContent = notaryFeeandCostsNotarizationContent.replace("{notaryFeeandCostsNotarization}", notaryFeeandCostsNotarization_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{notaryFeeandCostsNotarization}']").html(notaryFeeandCostsNotarizationContent);
		$("[data-output-summary='{notaryFeeandCostsNotarization}']").html(notaryFeeandCostsNotarization_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 6
		//var annualPremiumInsuranceContent = $("[name='{annualPremiumInsurance}']").html();
		//annualPremiumInsuranceContent = annualPremiumInsuranceContent.replace("{annualPremiumInsurance}", annualPremiumInsurance_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{annualPremiumInsurance}']").html(annualPremiumInsuranceContent);
		$("[data-output-summary='{annualPremiumInsurance}']").html(annualPremiumInsurance_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 7
		//var cadastreFeeMortgageRegistrationContent = $("[name='{cadastreFeeMortgageRegistration}']").html();
		//cadastreFeeMortgageRegistrationContent = cadastreFeeMortgageRegistrationContent.replace("{cadastreFeeMortgageRegistration}", cadastreFeeMortgageRegistration_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{cadastreFeeMortgageRegistration}']").html(cadastreFeeMortgageRegistrationContent);
		$("[data-output-summary='{cadastreFeeMortgageRegistration}']").html(cadastreFeeMortgageRegistration_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// 8
		//var rewardAndCostsNotariesContent = $("[name='{rewardAndCostsNotaries}']").html();
		//rewardAndCostsNotariesContent = rewardAndCostsNotariesContent.replace("{rewardAndCostsNotaries}", rewardAndCostsNotaries_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{rewardAndCostsNotaries}']").html(rewardAndCostsNotariesContent);
		$("[data-output-summary='{rewardAndCostsNotaries}']").html(rewardAndCostsNotaries_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		// total
		//var totalExpensesBeforeLoanContent = $("[name='{totalExpensesBeforeLoan}']").html();
		//totalExpensesBeforeLoanContent = totalExpensesBeforeLoanContent.replace("{totalExpensesBeforeLoan}", totalExpensesBeforeLoan_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		//$("[name='{totalExpensesBeforeLoan}']").html(totalExpensesBeforeLoanContent);
		$("[data-output-summary='{totalExpensesBeforeLoan}']").html(totalExpensesBeforeLoan_toShow.toString().replace(".", ",").replace(regexNumbers, "."));
		
		
		// SET sessionMortgageVariables
		var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
		var JSON_Obj = sessionStorageMortgage ? JSON.parse(sessionStorageMortgage) : {};
		
		var mass_uppermass = "";
		var isMagnifica = "false";
		
		var productIdMagnifica = "";
		var productNameMagnifica = "";
		if ($("[name=summaryMortgageProductMagnifica]").length){
			productIdMagnifica = $("[name=summaryMortgageProductMagnifica]").attr("data-mortgage-summary-product-id-magnifica");
			productNameMagnifica = $("[name=summaryMortgageProductMagnifica]").attr("data-mortgage-summary-product-name-magnifica");
		}
		
		var productIdRetail = "";
		var productNameRetail = "";
		if ($("[name=summaryMortgageProductRetail]").length){
			productIdRetail = $("[name=summaryMortgageProductMagnifica]").attr("data-mortgage-summary-product-id-retail");
			productNameRetail = $("[name=summaryMortgageProductMagnifica]").attr("data-mortgage-summary-product-name-retail");
		}
		
		if(monthlyIncome < 700){
			mass_uppermass = "mass";
			JSON_Obj[0].summary.productId = productIdRetail.substring(0,2);
			JSON_Obj[0].summary.productName = productNameRetail;
		}
		else if(monthlyIncome < 1500){
			mass_uppermass = "uppermass";
			JSON_Obj[0].summary.productId = productIdRetail.substring(0,2);
			JSON_Obj[0].summary.productName = productNameRetail;
		}
		else{
			isMagnifica = "true";
			mass_uppermass = "";
			JSON_Obj[0].summary.productId = productIdMagnifica.substring(0,2);
			JSON_Obj[0].summary.productName = productNameMagnifica;
		}
		
		if(JSON_Obj[0] !== undefined && JSON_Obj[0] !== null){
			JSON_Obj[0].summary.isMagnifica = isMagnifica;
			JSON_Obj[0].summary.mass_uppermass = mass_uppermass;
			JSON_Obj[0].summary.loanAmountSummary = loanAmount_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.monthlyInstallmentDesired = monthlyInstallmentDesired.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.maxLoanAmount = maxLoanAmount_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.processingFee = processingFee_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.maxMonthlyInstallment = maxMonthlyInstallment_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.vatRefund = vatRefund_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.minValueCollateralForMaxLoanAmount = minValueCollateralForMaxLoanAmount_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.cadastreFee = cadastreFee_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.cbReportFee = cbReportFee_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.estimationMarketValueRealEstate = estimationMarketValueRealEstate_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.billsOfExchange = billsOfExchange_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.notaryFeeandCostsNotarization = notaryFeeandCostsNotarization_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.annualPremiumInsurance = annualPremiumInsurance_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.cadastreFeeMortgageRegistration = cadastreFeeMortgageRegistration_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.rewardAndCostsNotaries = rewardAndCostsNotaries_toShow.toString().replace(regexNumbers, " ");
			JSON_Obj[0].summary.totalExpensesBeforeLoan = totalExpensesBeforeLoan_toShow.toString().replace(regexNumbers, " ");
		}
		
		sessionStorage.setItem('mortgageJSON', JSON.stringify(JSON_Obj));
		
	}
	
	
	this.setProductName = function(){
		var productName = formsBIB.sessionMortgage[0]['form1']['productName'];
		if(productName != null ){
			var arr = productName.split(" ");
	
			for (var i = 0; i < arr.length; i++) {
			    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
			}
	
			var finalProductName = arr.join(" ");
			
			if ($(".productName").length > 0) {
				$(".productName").each(function () {
					var thistitle = $(this).html();
					thistitle = thistitle.replace("${productName}", finalProductName);
					$(this).html(thistitle);
				})
			}
		}
	}
	
	
	$('[name="pricePropertyNew"]').on( 'change input', function() {
		var priceSessionStorage = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2['pricePropertyNew'].replace( /\./g, '' ).replace(/\s/g, '' );
		var priceInDom = $('[name="pricePropertyNew"]').val().replace( /\./g, '' ).replace(/\s/g, '' );
		if(priceSessionStorage !== priceInDom){
			$('[name="downpaymentProperty"]').val("");
		}
	});
	
	$('[name="pricePropertyOld"]').on( 'change input', function() {
		var priceSessionStorage = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2['pricePropertyOld'].replace( /\./g, '' ).replace(/\s/g, '' );
		var priceInDom = $('[name="pricePropertyOld"]').val().replace( /\./g, '' ).replace(/\s/g, '' );
		if(priceSessionStorage !== priceInDom){
			$('[name="downpaymentProperty"]').val("");
		}
	});

	
	this.setAndCheckDownPayment = function (){
		var stringToGoIntoTheRegex = "\\B(?=(\\d{3})+(?!\\d))";
		var regexNumbers = new RegExp(stringToGoIntoTheRegex, "g");
		
		var minPercentage = parseFloat($('[name="downpaymentProperty"]').attr("data-mortgage-min-percentage"));
		var maxPercentage = parseFloat($('[name="downpaymentProperty"]').attr("data-mortgage-max-percentage"));
		var defaultPercentage = parseFloat($('[name="downpaymentProperty"]').attr("data-mortgage-default-percentage"));
		var valueOfPropertyOld = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2['pricePropertyOld'];
		var valueOfPropertyNew = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2['pricePropertyNew'];
		var valueOfProperty ;
		if(valueOfPropertyOld !== "" && valueOfPropertyOld !== 0 && valueOfPropertyOld !== undefined && valueOfPropertyOld !== null){
			valueOfPropertyOld = valueOfPropertyOld.replace( /\./g, '' );
			valueOfPropertyOld = valueOfPropertyOld.replace(/\s/g, '' );
			valueOfProperty = parseInt(valueOfPropertyOld);
		}
		else if(valueOfPropertyNew !== "" && valueOfPropertyNew !== 0 && valueOfPropertyNew !== undefined && valueOfPropertyNew !== null){
			valueOfPropertyNew = valueOfPropertyNew.replace( /\./g, '' );
			valueOfPropertyNew = valueOfPropertyNew.replace(/\s/g, '' );
			valueOfProperty = parseInt(valueOfPropertyNew);
		}
		var maxValueProperty = Math.ceil( (valueOfProperty * maxPercentage) / 100 );
		var minValueProperty = Math.floor( (valueOfProperty * minPercentage) / 100 );
		var defaultValueProperty = Math.floor( (valueOfProperty * defaultPercentage) / 100 );
		
		$('[name="downpaymentProperty"]').attr("data-parsley-min", minValueProperty);
		$('[name="downpaymentProperty"]').attr("data-parsley-max", maxValueProperty);
		
		var errorDownpayment = $('[name="downpaymentProperty"]').attr("data-parsley-error-message");
		if(errorDownpayment.includes('<span')){
			errorDownpayment = errorDownpayment.replace(/<span id='minValueDownpayment'>.*<\/span>/, "<span id='minValueDownpayment'>" + minValueProperty.toString().replace(".", ",").replace(regexNumbers, ".") + "</span>");
			errorDownpayment = errorDownpayment.replace(/<div style='display:inline' id='maxValueDownpayment'>.*<\/div>/, "<div style='display:inline' id='maxValueDownpayment'>" + maxValueProperty.toString().replace(".", ",").replace(regexNumbers, ".") + "</div>");
		}
		else{
			errorDownpayment = errorDownpayment.replace("{minValueDownpayment}", "<span id='minValueDownpayment'>" + minValueProperty.toString().replace(".", ",").replace(regexNumbers, ".") + "</span>");
			errorDownpayment = errorDownpayment.replace("{maxValueDownpayment}", "<div style='display:inline' id='maxValueDownpayment'>" + maxValueProperty.toString().replace(".", ",").replace(regexNumbers, ".") + "</div>");	
		}
		$('[name="downpaymentProperty"]').attr("data-parsley-error-message", errorDownpayment);
			
		if($('[name="downpaymentProperty"]').val() == "" || $('[name="downpaymentProperty"]').val() == null || $('[name="downpaymentProperty"]').val() == undefined || isNaN($('[name="downpaymentProperty"]').val().replace( /\./g, '' ).replace(/\s/g, '' ))){
			// $('[name="downpaymentProperty"]').val(minValueProperty.toString().replace(".", ",").replace(regexNumbers, "."));
			$('[name="downpaymentProperty"]').val(defaultValueProperty.toString().replace(regexNumbers, "."));
		}
		else{
			$('[name="downpaymentProperty"]').parsley().destroy();
			var inputVal = $('[name="downpaymentProperty"]').val();
	        var inputVal_old = $('[name="downpaymentProperty"]').val();
			inputVal = inputVal.replace( /\./g, '' );
			inputVal = inputVal.replace(/\s/g, '' );
			$('[name="downpaymentProperty"]').val(inputVal);
			$('[name="downpaymentProperty"]').parsley().validate();
			$('[name="downpaymentProperty"]').val(inputVal_old);
	        var step = formsBIB.getStep();
			formsBIB.setNextActiveCheckingFields(step);
		}
		
		var name = $('[name="downpaymentProperty"]').attr("name");
		var value = $('[name="downpaymentProperty"]').val();
		if(formsBIB.sessionMortgage[0]["form2"][name] !== undefined){
			formsBIB.sessionMortgage[0]["form2"][name] = value;
		}
		
	}
	
	
	this.setAndCheckBirthDate = function (){
		
		var minAge = parseFloat($('[name="mortgageBirthDate"]').attr("data-mortgage-years-min"));
		var maxAge = parseFloat($('[name="mortgageBirthDate"]').attr("data-mortgage-years-max"));
		var minRepaymentMonths = parseFloat($('[name="mortgageRepaymentMonths"]').attr("data-mortgage-repayment-min"));
		var minAgeDisplayed = minAge;
		var maxAgeDisplayed = (parseInt(maxAge) - Math.ceil((parseInt(minRepaymentMonths)/12)) ).toString();
		
		var todayDate = new Date();
		var year = todayDate.getFullYear();
	    var month = todayDate.getMonth();
	    var day = todayDate.getDate();
	    var maxDate = new Date(year - parseInt(minAge), month, day);
		var minDate = new Date(year - (parseInt(maxAge)), month + parseInt(minRepaymentMonths), day);  // metto più 1 ad anni per 71 anni // metto + 1 giorno per giorno dopo il compleanno
		
		var yearMax = maxDate.getFullYear();
		var monthMax = maxDate.getMonth() + 1;
		var dayMax = maxDate.getDate();
		if (dayMax < 10) dayMax = '0' + dayMax;
		if (monthMax < 10) monthMax = '0' + monthMax;

		var yearMin = minDate.getFullYear();
		var monthMin = minDate.getMonth() + 1;
		var dayMin = minDate.getDate();
		if (dayMin < 10) dayMin = '0' + dayMin;
		if (monthMin < 10) monthMin = '0' + monthMin;
		
		var maxDateFormatted = dayMax + '/' + monthMax + '/' + yearMax; 
		var minDateFormatted = dayMin + '/' + monthMin + '/' + yearMin; 
		
		$('[name="mortgageBirthDate"]').removeAttr("data-parsley-mindate");
		$('[name="mortgageBirthDate"]').removeAttr("data-parsley-maxdate");
		$('[name="mortgageBirthDate"]').attr("data-parsley-mindate", minDateFormatted);
		$('[name="mortgageBirthDate"]').attr("data-parsley-maxdate", maxDateFormatted);
		
		var maxDateDotted = dayMax + '.' + monthMax + '.' + yearMax; 
		var minDateDotted = dayMin + '.' + monthMin + '.' + yearMin; 
		$('[name="mortgageBirthDate"]').attr("data-min", minDateDotted);
		$('[name="mortgageBirthDate"]').attr("data-max", maxDateDotted);
		
		var errorBirthDate = $('[name="mortgageBirthDate"]').attr("data-parsley-error-message");
		var descriptionBirthDate = $('#descriptionQuestionBirthDate').html().toString();
		
		if(descriptionBirthDate.includes('{minBirthDateMortgage}')){
			descriptionBirthDate = descriptionBirthDate.replace("{minBirthDateMortgage}", "<span id='minBirthDateMortgage'>" + minAgeDisplayed + "</span>");
			descriptionBirthDate = descriptionBirthDate.replace("{maxBirthDateMortgage}", "<div style='display:inline' id='maxBirthDateMortgage'>" + maxAgeDisplayed + "</div>");	
		}
		
		if(errorBirthDate.includes('{minBirthDateMortgage}')){
			errorBirthDate = errorBirthDate.replace("{minBirthDateMortgage}", "<span id='minBirthDateMortgage'>" + minAgeDisplayed + "</span>");
			errorBirthDate = errorBirthDate.replace("{maxBirthDateMortgage}", "<div style='display:inline' id='maxBirthDateMortgage'>" + maxAgeDisplayed + "</div>");	
		}

		$('[name="mortgageBirthDate"]').attr("data-parsley-error-message", errorBirthDate);
		$('#descriptionQuestionBirthDate').html(descriptionBirthDate);
		
		var valueMortgageBirthDate = $('[name="mortgageBirthDate"]').val();
		if(valueMortgageBirthDate !== null && valueMortgageBirthDate !== undefined && valueMortgageBirthDate !== ""){				// se soluzione che non aggiorna dato commento questa riga e tolgo commento da quella dopo
			
			window.Parsley.addValidator("mindate", {
				validateString: function(value, requirements) {
					
					var reqs = value.replaceAll(".", "/");
					
					var dateInsertedParts = reqs.split("/");
					
					var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
				    if(dateInsertedParts[2] % 400 == 0 || (dateInsertedParts[2] % 100 != 0 && dateInsertedParts[2] % 4 == 0)){
				        monthLength[1] = 29;	
				    }
				    if(dateInsertedParts[0] > monthLength[dateInsertedParts[1] - 1]){
				    	return false;
				    }
					
					var dateInserted = new Date(+dateInsertedParts[2], dateInsertedParts[1] - 1, +dateInsertedParts[0]); 
					
					var dateMinimumRequiredParts = requirements.split("/");
					var dateMinimumRequired = new Date(+dateMinimumRequiredParts[2], dateMinimumRequiredParts[1] - 1, +dateMinimumRequiredParts[0]); 
					
					return dateInserted >= dateMinimumRequired;
				}
			});
			
			window.Parsley.addValidator("maxdate", {
				validateString: function(value, requirements) {
					
					var reqs = value.replaceAll(".", "/");
					
					var dateInsertedParts = reqs.split("/");
					
					var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
				    if(dateInsertedParts[2] % 400 == 0 || (dateInsertedParts[2] % 100 != 0 && dateInsertedParts[2] % 4 == 0)){
				        monthLength[1] = 29;	
				    }
				    if(dateInsertedParts[0] > monthLength[dateInsertedParts[1] - 1]){
				    	return false;
				    }
					
					var dateInserted = new Date(+dateInsertedParts[2], dateInsertedParts[1] - 1, +dateInsertedParts[0]); 
					
					var dateMaximumRequiredParts = requirements.split("/");
					var dateMaximumRequired = new Date(+dateMaximumRequiredParts[2], dateMaximumRequiredParts[1] - 1, +dateMaximumRequiredParts[0]); 
					
					return dateInserted <= dateMaximumRequired;
				}
			});
			
			$('[name="mortgageBirthDate"]').parsley().validate();
		}
		
	}

	
	this.setAndCheckRepaymentMonths = function (isUpdateDate){
		
		var minRepaymentMonths = parseFloat($('[name="mortgageRepaymentMonths"]').attr("data-mortgage-repayment-min"));
		var maxRepaymentMonths = parseFloat($('[name="mortgageRepaymentMonths"]').attr("data-mortgage-repayment-max"));
		
		var birthDateField = $('[name="mortgageBirthDate"]').val();
		
		var minRepaymentMonthsDisplayed;
		var maxRepaymentMonthsDisplayed;
		
		if(birthDateField === null || birthDateField === undefined || birthDateField === ""){
			minRepaymentMonthsDisplayed = minRepaymentMonths;
			maxRepaymentMonthsDisplayed = maxRepaymentMonths;
		}
		else{
			var maxAgeFeasible = parseInt($('[name="mortgageBirthDate"]').attr("data-mortgage-years-max"));
			var dateToCheck = birthDateField.replace( /\./g, '/' );
			
			var dateDateToCheckParts = dateToCheck.split("/");
			var dateDateToCheck = new Date(+dateDateToCheckParts[2], dateDateToCheckParts[1] - 1, +dateDateToCheckParts[0]); 
			
			var year = dateDateToCheck.getFullYear();
		    var month = dateDateToCheck.getMonth();
		    var day = dateDateToCheck.getDate();
		    var dateMaxBirthDate = new Date(year + (maxAgeFeasible), month, day); // metto più 1 per 71 anni
		    var dateOfToday = new Date();
		    
			var monthsDifference;
			monthsDifference = (dateMaxBirthDate.getFullYear() - dateOfToday.getFullYear()) * 12;
			monthsDifference -= dateOfToday.getMonth(); 	// + 1 ?
			monthsDifference += dateMaxBirthDate.getMonth();
			
			var todayDay = dateOfToday.getDate();
			if( day < todayDay ){	
				monthsDifference = monthsDifference - 1;
			}
			
			if(monthsDifference > parseInt(maxRepaymentMonths)){
				maxRepaymentMonthsDisplayed = maxRepaymentMonths;
			}
			else{
				maxRepaymentMonthsDisplayed = monthsDifference.toString();
			}
			
			minRepaymentMonthsDisplayed = minRepaymentMonths;
		}
		
		$('[name="mortgageRepaymentMonths"]').attr("data-parsley-min", minRepaymentMonthsDisplayed);
		$('[name="mortgageRepaymentMonths"]').attr("data-parsley-max", maxRepaymentMonthsDisplayed);
		
		var errorRepaymentMonths = $('[name="mortgageRepaymentMonths"]').attr("data-parsley-error-message");
		var descriptionRepaymentMonths = $('#descriptionQuestionRepayment').html().toString();
		
		if(descriptionRepaymentMonths.includes('{minRepaymentMonthsMortgage}')){
			var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
			if(isMobile){
				descriptionRepaymentMonths = descriptionRepaymentMonths.replace("-","<br>")
			}
			descriptionRepaymentMonths = descriptionRepaymentMonths.replace("{minRepaymentMonthsMortgage}", "<span id='minRepaymentMonthsMortgage'>" + minRepaymentMonthsDisplayed + "</span>");
			descriptionRepaymentMonths = descriptionRepaymentMonths.replace("{maxRepaymentMonthsMortgage}", '<div style="display:inline" id="maxRepaymentMonthsMortgage">' + maxRepaymentMonthsDisplayed + "</div>");	
		}
		else{
			descriptionRepaymentMonths = descriptionRepaymentMonths.replace(/<span id='minRepaymentMonthsMortgage'>.*<\/span>/, "<span id='minRepaymentMonthsMortgage'>" + minRepaymentMonthsDisplayed + "</span>");
			descriptionRepaymentMonths = descriptionRepaymentMonths.replace(/<div style="display:inline" id="maxRepaymentMonthsMortgage">.*<\/div>/, '<div style="display:inline" id="maxRepaymentMonthsMortgage">' + maxRepaymentMonthsDisplayed + "</div>");
		}
		
		if(errorRepaymentMonths.includes('{minRepaymentMonthsMortgage}')){
			errorRepaymentMonths = errorRepaymentMonths.replace("{minRepaymentMonthsMortgage}", "<span id='minRepaymentMonthsMortgage'>" + minRepaymentMonthsDisplayed + "</span>");
			errorRepaymentMonths = errorRepaymentMonths.replace("{maxRepaymentMonthsMortgage}", "<div style='display:inline' id='maxRepaymentMonthsMortgage'>" + maxRepaymentMonthsDisplayed + "</div>");	
		}
		else{
			errorRepaymentMonths = errorRepaymentMonths.replace(/<span id='minRepaymentMonthsMortgage'>.*<\/span>/, "<span id='minRepaymentMonthsMortgage'>" + minRepaymentMonthsDisplayed + "</span>");
			errorRepaymentMonths = errorRepaymentMonths.replace(/<div style='display:inline' id='maxRepaymentMonthsMortgage'>.*<\/div>/, "<div style='display:inline' id='maxRepaymentMonthsMortgage'>" + maxRepaymentMonthsDisplayed + "</div>");
		}

		$('[name="mortgageRepaymentMonths"]').attr("data-parsley-error-message", errorRepaymentMonths);
		$('#descriptionQuestionRepayment').html(descriptionRepaymentMonths);
		
		
		if(birthDateField !== null && birthDateField !== undefined && birthDateField !== ""){
			var valueRepaymentMonths = $('[name="mortgageRepaymentMonths"]').val();
			if(valueRepaymentMonths !== null && valueRepaymentMonths !== undefined && valueRepaymentMonths !== ""){
				if(isUpdateDate){
					$('[name="mortgageRepaymentMonths"]').val(maxRepaymentMonthsDisplayed);						// se soluzione che non aggiorna dato commento questa riga e tolgo commento da quella dopo
				}
				$('[name="mortgageRepaymentMonths"]').parsley().validate();
		        var step = formsBIB.getStep();
				formsBIB.setNextActiveCheckingFields(step);
			}else{
				$('[name="mortgageRepaymentMonths"]').val(maxRepaymentMonthsDisplayed);
				if($('[name="mortgageRepaymentMonths"]').hasClass("fc-primary")){
					$('[name="mortgageRepaymentMonths"]').addClass("fc-edited");
				}
				$('[name="mortgageRepaymentMonths"]').parsley().validate();
				
			}
			
			var name = $('[name="mortgageRepaymentMonths"]').attr("name");
			var value = $('[name="mortgageRepaymentMonths"]').val();
			if(formsBIB.sessionMortgage[0]["form2"][name] !== undefined){
				formsBIB.sessionMortgage[0]["form2"][name] = value;
			}
			
		}
		
	}
	
	
	
	this.checkMobileOrDesktopQuestionOne = function (){
		var step = formsBIB.getStep();
		var dataStepNew = parseInt(step);
		var myForm = $('input[name="myForm"]').val();
		
		if(myForm == 'form1' && dataStepNew == 1){
			$('#submit').addClass('mobileVersion');
			$('#previous').addClass('desktopVersion');
		}
		else{
			$('#submit').removeClass('mobileVersion');
			$('#previous').removeClass('desktopVersion');
		}
	}
	
	
	
	this.freeEmptyField = function () {
		var step = formsBIB.getStep();
		var dataStepNew = parseInt(step);
		var myForm = $('input[name="myForm"]').val();
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('input:hidden').each(function (idx) {
			var name = this['name'];
			var type = this['type'];
			if(formsBIB.sessionMortgage[0][myForm][name]){
				formsBIB.sessionMortgage[0][myForm][name] = '';
			}
			if(type == 'radio'){
				$(".rstepwrapper").eq(dataStepNew - 1).find('input:hidden').eq(idx).parent().removeClass('active');
				this['checked'] = false;
			}
			else{
				this['value'] = '';
			}
		});
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('[data-val]:hidden').each(function (idx) {
			var name = $(this).attr("name");
			if(formsBIB.sessionMortgage[0][myForm][name]){
				formsBIB.sessionMortgage[0][myForm][name] = '0';
			}
			
		});
	}
	
	
	
	this.setNextActiveCheckingFields = function (step) {
		var compiled = true;
		var dataStepNew = parseInt(step);
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('input:visible').each(function () {
			var type = this['type'];
			if(type == 'radio'){
				var name = this['name'];
				if($(".rstepwrapper").eq(dataStepNew - 1).find("input[name=" + name + "]:checked").length == 0){
					compiled = false;
				}
			}
			else{
				if(this['value'] == "" || this['value'] == null ||this['value'] == undefined){
					compiled = false;
				}
			}
		});
		
		if(compiled){
			if($(".parsley-custom-error-message:visible").length > 0){
				formsBIB.disableNext($('button.r-btn-next'));
			}
			else{
				formsBIB.setActiveNext($('button.r-btn-next'));
				formsBIB.checkMinCollateral();		// DA VERIFICARE
			}
		}
		else{
			formsBIB.disableNext($('button.r-btn-next'));
		}
	}
	
	$('#mortgage_dateYear').focusin(function(){
		$(".dataPickerContainerMortgage").addClass("fc-edited");
		var step = formsBIB.getStep();
		formsBIB.setNextActiveCheckingFields(step);
	});
	
	$('#mortgage_dateYear').focusout(function(){
		if($('#mortgage_dateYear').val() !== '' && $('#mortgage_dateYear').val() !== null && $('#mortgage_dateYear').val() !== undefined){
	    	$(".dataPickerContainerMortgage").addClass("fc-edited");
	    	formsBIB.sessionMortgage[0]["form2"]["mortgageBirthDate"] = $('#mortgage_dateYear').val();
	    	var step = formsBIB.getStep();
			formsBIB.setNextActiveCheckingFields(step);
	    }
	    else{
	    	$(".dataPickerContainerMortgage").removeClass("fc-edited");
	    }
	});
	
	
	$('#mortgage_dateYear').on( 'change input', function() {
		if($('#mortgage_dateYear').val() !== '' && $('#mortgage_dateYear').val() !== null && $('#mortgage_dateYear').val() !== undefined){
	    	$(".dataPickerContainerMortgage").addClass("fc-edited");
			formsBIB.sessionMortgage[0]["form2"]["mortgageBirthDate"] = $('#mortgage_dateYear').val();
	    }
	    else{
	    	$(".dataPickerContainerMortgage").removeClass("fc-edited");
	    }
		var step = formsBIB.getStep();
		formsBIB.setNextActiveCheckingFields(step);
	});
	
	
	$( document ).on( 'change input', '[data-mortgage-input=checkMortgageInputNumerical]', function() {
			
		if($(this).attr("name") !== "mortgageBirthDate"){
			$(this).parsley().destroy();
			var inputVal = $(this).val();
	        var inputVal_old = $(this).val();
			if($(this).attr("name") === "creditCardDebt" || $(this).attr("name") === "codebtorCreditCardDebt"){
				inputVal_old = inputVal_old.replace( /\-/g, '' );
		        inputVal = inputVal.replace( /\-/g, '' );
			}
			if(inputVal.includes(",")){
				inputVal_old =  inputVal_old.substring(0, inputVal_old.indexOf(','));
		        inputVal =  inputVal.substring(0, inputVal.indexOf(','));
			}
	        inputVal_old = inputVal_old.replace( /\,/g, '' );
	        inputVal = inputVal.replace( /\,/g, '' );
			inputVal = inputVal.replace( /\./g, '' );
			inputVal = inputVal.replace(/\s/g, '' );
			$(this).val(inputVal);
			$(this).parsley().validate();
	        $(this).val(inputVal_old);
	        var step = formsBIB.getStep();
			formsBIB.setNextActiveCheckingFields(step);
		}
		else{
			$(this).parsley().destroy();
			var inputVal = $(this).val();
	        var inputVal_old = $(this).val();
			inputVal = inputVal.replace( /\./g, '/' );
			// var dateInputVal = new Date(inputVal);
			// $(this).val(inputVal);
			
			window.Parsley.addValidator("mindate", {
				validateString: function(value, requirements) {
					
					var reqs = value.replaceAll(".", "/");
					
					var dateInsertedParts = reqs.split("/");
					
					var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
				    if(dateInsertedParts[2] % 400 == 0 || (dateInsertedParts[2] % 100 != 0 && dateInsertedParts[2] % 4 == 0)){
				        monthLength[1] = 29;	
				    }
				    if(dateInsertedParts[0] > monthLength[dateInsertedParts[1] - 1]){
				    	return false;
				    }
					
					var dateInserted = new Date(+dateInsertedParts[2], dateInsertedParts[1] - 1, +dateInsertedParts[0]); 
					
					var dateMinimumRequiredParts = requirements.split("/");
					var dateMinimumRequired = new Date(+dateMinimumRequiredParts[2], dateMinimumRequiredParts[1] - 1, +dateMinimumRequiredParts[0]); 
					
					return dateInserted >= dateMinimumRequired;
				}
			});
			
			window.Parsley.addValidator("maxdate", {
				validateString: function(value, requirements) {
					
					var reqs = value.replaceAll(".", "/");
					
					var dateInsertedParts = reqs.split("/");
					
					var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
				    if(dateInsertedParts[2] % 400 == 0 || (dateInsertedParts[2] % 100 != 0 && dateInsertedParts[2] % 4 == 0)){
				        monthLength[1] = 29;	
				    }
				    if(dateInsertedParts[0] > monthLength[dateInsertedParts[1] - 1]){
				    	return false;
				    }
					
					var dateInserted = new Date(+dateInsertedParts[2], dateInsertedParts[1] - 1, +dateInsertedParts[0]); 
					
					var dateMaximumRequiredParts = requirements.split("/");
					var dateMaximumRequired = new Date(+dateMaximumRequiredParts[2], dateMaximumRequiredParts[1] - 1, +dateMaximumRequiredParts[0]); 
					
					return dateInserted <= dateMaximumRequired;
				}
			});
			
			var validateDate = $(this).parsley().validate();
	        $(this).val(inputVal_old);
	        var step = formsBIB.getStep();
			formsBIB.setNextActiveCheckingFields(step);
			if(validateDate === true){
				formsBIB.setAndCheckRepaymentMonths(true);
			}
		}
	});
	
	
	
	$('#summaryVideochat').on("click", function () {
		
		var contentTypeOfAppointment = $('#summaryVideochat').attr("data-mail-content");
		
		var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
		var JSON_Obj = sessionStorageMortgage ? JSON.parse(sessionStorageMortgage) : {};
		if(JSON_Obj[0] !== undefined && JSON_Obj[0] !== null && JSON_Obj[0].hasOwnProperty('typeOfAppointment')){
			JSON_Obj[0].typeOfAppointment = contentTypeOfAppointment;
		}
		sessionStorage.setItem('mortgageJSON', JSON.stringify(JSON_Obj));
		
	    $('#summaryVideochat')[0].innerHTML = '<span><img alt = "" aria-hidden = "true" class="loading-mortgage" width="22" height="22"></img></span>';
	    $('#summaryVideochat')[0].disabled = true;
		
		window.location.replace($('#summaryVideochat').attr("data-redirect-link"));

	});
	
	
	$('#summaryInBranch').on("click", function () {
		
		var contentTypeOfAppointment = $('#summaryInBranch').attr("data-mail-content");

		var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
		var JSON_Obj = sessionStorageMortgage ? JSON.parse(sessionStorageMortgage) : {};
		if(JSON_Obj[0] !== undefined && JSON_Obj[0] !== null && JSON_Obj[0].hasOwnProperty('typeOfAppointment')){
			JSON_Obj[0].typeOfAppointment = contentTypeOfAppointment;
		}
		sessionStorage.setItem('mortgageJSON', JSON.stringify(JSON_Obj));
		
	    $('#summaryInBranch')[0].innerHTML = '<span><img alt = "" aria-hidden = "true" class="loading-mortgage" width="22" height="22"></img></span>';
	    $('#summaryInBranch')[0].disabled = true;
		
		window.location.replace($('#summaryInBranch').attr("data-redirect-link"));

	});
	
	
	
	this.scoreFunction = function () {
		var myForm = $('input[name="myForm"]').val();
		var dataStepNew = formsBIB.getStep() - 1;
		if(myForm == 'form1' && dataStepNew == 0){
			formsBIB.score1 = $(".rstepwrapper").eq(dataStepNew - 1).find('input:checked').attr('js-data-score');
			sessionStorage.setItem('score1', JSON.stringify(formsBIB.score1));
		}
		
		var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
		var JSON_Obj = sessionStorageMortgage ? JSON.parse(sessionStorageMortgage) : {};
		JSON_Obj[0].score = formsBIB.score1;
		sessionStorage.setItem('mortgageJSON', JSON.stringify(JSON_Obj));
	} 
	
	
	
	this.writeInput = function () {
		var arrInput = Array.from($('.control-input-mortgage'))
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		var myForm = $('input[name="myForm"]').val();
		var JSON_Obj = sessionJSON ? JSON.parse(sessionJSON) : {};
		
		if (JSON_Obj && JSON_Obj[0]){
			arrInput.forEach(function (input) {
				var name = input.name;
				if(JSON_Obj[0][myForm][name]['length'] > 0){
					if (input['type'] == "radio") {
						if(input['name'] == name && input['value'] == JSON_Obj[0][myForm][name]){
							input.click();
						}
					}
					else{
						input['value'] = JSON_Obj[0][myForm][name];
						if(name == "mortgageBirthDate"){
							$(".dataPickerContainerMortgage").addClass("fc-edited");
						}
						$('[name="' + name + '"]').addClass("fc-edited");
					}
				}
			})
		}
		
		if(myForm === "form2"){
			var nameHousehold = "householdMembers";
			var valueHousehold = JSON_Obj[0][myForm][nameHousehold];
			$('#' + nameHousehold).html(valueHousehold);
			var maxValueHousehold = parseInt($('[name="' + nameHousehold + '"]').attr("data-maximum"));
			if(parseInt(valueHousehold) === 0){
				$('[name="householdMembersMinus"]').addClass("disabled");
				$('[name="householdMembersPlus"]').removeClass("disabled");
			}
			else if(parseInt(valueHousehold) === maxValueHousehold){
				$('[name="householdMembersMinus"]').removeClass("disabled");
				$('[name="householdMembersPlus"]').addClass("disabled");
			}
			else{
				$('[name="householdMembersMinus"]').removeClass("disabled");
				$('[name="householdMembersPlus"]').removeClass("disabled");
			}
			
			var nameCollateralProperties = "collateralProperties";
			var valueCollateralProperties = JSON_Obj[0][myForm][nameCollateralProperties];
			$('#' + nameCollateralProperties).html(valueCollateralProperties);
			var maxValueCollateralProperties = parseInt($('[name="' + nameCollateralProperties + '"]').attr("data-maximum"));
			if(parseInt(valueCollateralProperties) === 0){
				$('[name="collateralPropertiesMinus"]').addClass("disabled");
				$('[name="collateralPropertiesPlus"]').removeClass("disabled");
			}
			else if(parseInt(valueCollateralProperties) === maxValueCollateralProperties){
				$('[name="collateralPropertiesMinus"]').removeClass("disabled");
				$('[name="collateralPropertiesPlus"]').addClass("disabled");
			}
			else{
				$('[name="collateralPropertiesMinus"]').removeClass("disabled");
				$('[name="collateralPropertiesPlus"]').removeClass("disabled");
			}
		}
		
		if(sessionStorage.getItem('next')) {
			var step = formsBIB.getStep();
			formsBIB.setNextActiveCheckingFields(step);
		}
		
		if(sessionStorage.getItem('back')) {
			formsBIB.setActiveNext($('button.r-btn-next'));
		}
	}
	
	
	
	this.initStep = function () {
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		var myForm = $('input[name="myForm"]').val();
		
		if (sessionStorage.getItem('back') == 'true') {
			if (myForm == 'form1') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep1').removeClass('rhide');
				dataNewStep = 1;
			}
			if (myForm == 'form2') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep4').removeClass('rhide');
				dataNewStep = 4;
			}
			if (myForm == 'form3') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep1').removeClass('rhide');
				dataNewStep = 3;
			}
			
			window.intesa.formsBIB.setStep(dataNewStep);
			window.intesa.formsBIB.refreshStep(dataNewStep);
			
		}
		if (sessionStorage.getItem('next') == 'true') {
			$('.rstepwrapper').addClass('rhide');
			$('.rstep1').removeClass('rhide');
			dataNewStep = 1;
			
			window.intesa.formsBIB.setStep(dataNewStep);
			window.intesa.formsBIB.refreshStep(dataNewStep);
		}
	}
	
	

	this.stepByStorage = function () {
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form1[key].length > 0 && sessionStorage.getItem('next') != 'true') {
						showStep(key);
						$('input[name="' + key + '"]').each(function () {
							var self = this;
							if ($(self).val() == JSON_Obj[0].form1[key]) {
								$(self).attr('checked', true).parent('label').trigger('click');
							}
						});

						switch (key) {
							case "propertyFound":
								formsBIB.setStep(1);
								formsBIB.refreshStep(1);
								$('.rstep1').removeClass('rhide');
								break;
							default:
								break;
						}
					}
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form2[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						if ($(self).attr('type') != "radio") {
							$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);
						}

						var stepNumber = parseInt(formsBIB.getStep());
						$(".rstepwrapper").eq(stepNumber - 1).find('input[name="' + key + '"]').trigger("keyup");

						switch (key) {
							case "propertyType":
								formsBIB.setStep(1);
								formsBIB.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');
								break;
							case "downpaymentProperty":
								formsBIB.setStep(2);
								formsBIB.refreshStep(2);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep2').removeClass('rhide');
								break;
							case "propertySubject":
								formsBIB.setStep(3);
								formsBIB.refreshStep(3);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep3').removeClass('rhide');
								break;
							case "mortgageBirthDate":
								formsBIB.setStep(4);
								formsBIB.refreshStep(4);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep4').removeClass('rhide');
								break;
							default:
						}
					}
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form3[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						switch (key) {
							case "debtorPresence":
								formsBIB.setStep(1);
								formsBIB.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');
								break;
							case "":
								formsBIB.setStep(2);
								formsBIB.refreshStep(2);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep2').removeClass('rhide');
								break;
							case "":
								formsBIB.setStep(3);
								formsBIB.refreshStep(3);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep3').removeClass('rhide');
								break;
							default:
						}
						
						/*if (key == "valueOfProperty") {
							formsBIB.setStep(1);
							formsBIB.refreshStep(1);
							$('.rstep1').removeClass('rhide');
						}*/
					}

					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger('focus');
					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger("keyup");

				}
			}
		}
	}


	function showStep(key_obj) {
		$('.rstepwrapper').addClass('rhide');

		if (key_obj.indexOf('One') > -1) {
			$('.rstep1').removeClass('rhide');
			formsBIB.setStep(1);
			formsBIB.refreshStep(1);
		}
		if (key_obj.indexOf('Two') > -1) {
			$('.rstep2').removeClass('rhide');
			formsBIB.setStep(2);
			formsBIB.refreshStep(2);
		}
		if (key_obj.indexOf('Three') > -1) {
			$('.rstep3').removeClass('rhide');
			formsBIB.setStep(3);
			formsBIB.refreshStep(3);
		}
		if (key_obj.indexOf('Four') > -1) {
			$('.rstep4').removeClass('rhide');
			formsBIB.setStep(4);
			formsBIB.refreshStep(4);
		}
		if (key_obj.indexOf('Five') > -1) {
			$('.rstep5').removeClass('rhide');
			formsBIB.setStep(5);
			formsBIB.refreshStep(5);
		}
	}



	this.goToNext = function () {
		$(document).on('click', 'button.r-btn-next', function (e) {
			
			formsBIB.freeEmptyField();

			sessionStorage.removeItem('back');
			sessionStorage.removeItem('next');

			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) + 1;

			var myForm = $('input[name="myForm"]').val();

			sessionStorage.setItem('mortgageJSON', JSON.stringify(formsBIB.sessionMortgage));

			if (myForm == 'form1') {
				sessionStorage.setItem('mortgageStep', '1');
			}
			if (myForm == 'form2') {
				sessionStorage.setItem('mortgageStep', '2');
				
				if($('[name="downpaymentProperty"]').length > 0){
					formsBIB.setAndCheckDownPayment();
				}
				if($('[name="mortgageBirthDate"]').length > 0){
					formsBIB.setAndCheckBirthDate();
				}
				if($('[name="mortgageRepaymentMonths"]').length > 0){
					if (dataStepNew <= $("#numberofsteps").val()){
						formsBIB.setAndCheckRepaymentMonths(false);
					}
				}
				
			}
			if (myForm == 'form3') {
				sessionStorage.setItem('mortgageStep', '3');
			}

			if (dataStepNew > $("#numberofsteps").val()) {
				var myForm = $('input[name="myForm"]').val();
				
				var sessionStorageMortage = sessionStorage.getItem('mortgageJSON') || "";
				if (sessionStorageMortage !== "") {
					if (sessionStorageMortage.length > 0) {
						var JSON_Obj = JSON.parse(sessionStorageMortage);
					}
				}

				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					for (var key in JSON_Obj[0].form1) {
						if (JSON_Obj[0].form1[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					for (var key in JSON_Obj[0].form2) {
						if (JSON_Obj[0].form2[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
					for (var key in JSON_Obj[0].form3) {
						if (JSON_Obj[0].form3[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].summary) {
					for (var key in JSON_Obj[0].summary) {
						if (JSON_Obj[0].summary[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].summary[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].score) {
					var scoreSum = JSON_Obj[0].score;
					var priority = scoreSum;
					
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="priorityMortgage" value="' + priority + '"/>');
				}
				
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].typeOfAppointment) {
					var typeOfAppointment = JSON_Obj[0].typeOfAppointment;
					
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="typeOfAppointment" value="' + typeOfAppointment + '"/>');
				}
				
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].summary && JSON_Obj[0].summary.isMagnifica) {
					var customerType = "";
					if(JSON_Obj[0].summary.isMagnifica == "true"){
						customerType =  $("[name=emailSubjectCustomerType]").attr("data-mortgage-magnifica-customer-email-placeholder");
					}
					else{
						customerType =  $("[name=emailSubjectCustomerType]").attr("data-mortgage-intesacasa-customer-email-placeholder");
					}
					
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="customerType" value="' + customerType + '"/>');
				}
				
				$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
				$('form[name="formThanksMortgage"]').submit();
				
			} else {
				formsBIB.disableNext($('button.r-btn-next'));

				var myForm = $('input[name="myForm"]').val();

				if (myForm == 'form1') {

					//setTimeout(function () {

						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {

							$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');

						} else {

							formsBIB.disableNext(self);

						}

					//}, 100);

				}

				if (myForm == 'form2') {

					//setTimeout(function () {

						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {

							// if (dataStepNew - 1 == 1) {
							// 	for (var i = 0; i < mortgageForm["debitors"]; i++) {
							// 		$(".rstepwrapper").eq(dataStepNew - 1).find('.col-md-10')[i].classList.remove('rhide');
							// 	}
							// }
							
							var stepNum = parseInt(formsBIB.getStep());
							var debitors_num = $(".rstepwrapper").eq(stepNum - 1).find('div[data-val]')[0];
							if(debitors_num && debitors_num != null && debitors_num != undefined){
								if(parseInt(debitors_num.innerText) >= 0){
									//formsBIB.setActiveNext($('button.r-btn-next'));
									var stepNextActive = formsBIB.getStep();
									formsBIB.setNextActiveCheckingFields(stepNextActive);
								}
							}

							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':visible')) {
									self.trigger("keyup");
								}
							});
							
							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':checked')) {
									//self.trigger("click");
									var stepNextActive = formsBIB.getStep();
									formsBIB.setNextActiveCheckingFields(stepNextActive);
								}
							});

						} else {

							formsBIB.disableNext($('button.r-btn-next'));
						}

					//}, 100);

				}
				
				var step = formsBIB.getStep();
				var dataStepNew2 = parseInt(step);
				if ($(".rstepwrapper").eq(dataStepNew2 - 1).find('input[data-ok]:checked').hasClass("not_eligible")) {
					window.location.replace($("#submit").attr("data-redirect-not-eligible"));
				}
				else{
					formsBIB.refreshStep(dataStepNew);
					formsBIB.setStep(dataStepNew);

					$('.rstepwrapper').addClass('rhide');
					$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');
				}
				
				/*if ($(".rstepwrapper").eq(dataStepNew - 2).find('input[data-ok]:checked').hasClass("not_eligible")) {
					window.location.replace($("#submit").attr("data-redirect-not-eligible"));
				}*/
				
			}
			
			//formsBIB.writeInput();
			// formsBIB.checkMobileOrDesktopQuestionOne();

			formsBIB.scrollToTop();
			
			var step = parseInt(formsBIB.getStep());
			formsBIB.setNextActiveCheckingFields(step);
			formsBIB.scoreFunction();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
			
			if ($(".rstepwrapper").eq(dataStepNew - 2).find('input[data-ok]:checked:visible').hasClass("not_eligible")) {
				window.location.replace($("#submit").attr("data-redirect-not-eligible"));
			}
			else{
				if (dataStepNew > $("#numberofsteps").val()) {
					sessionStorage.setItem('next', "true");
					
			        $('.r-btn-nextMortgage')[0].innerHTML = '<span><img alt = "" aria-hidden = "true" class="loading-mortgage" width="22" height="22"></img></span>';
			        $('.r-btn-nextMortgage')[0].disabled = true;
			
					var myForm = $('input[name="myForm"]').val();
					
					// TODO: capire come prendere il valore da controllare
					if (myForm == 'form2' && formsBIB.sessionMortgage[0].form1.mortgage == 'WITHOUT_MORTGAGE') {
						window.location.replace($("#submit").attr("data-redirect-contact"));
					}
					else{
						window.location.replace($("#submit").attr("data-redirect"));
					}
				}
			}
		});
	};

	//scroll to top
	this.scrollToTop = function () {
		 $('.r-component-wrapper')[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
	}

	//if ($(".r-form-top-section").length > 0) {
	//	formsBIB.scrollToTop();
	//}

	this.goBackStep = function () {
		$(document).on('click', 'button.r-btn-back', function (e) {
			
			formsBIB.freeEmptyField();

			sessionStorage.removeItem('next');
			sessionStorage.removeItem('back');
			
			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var myForm = $('input[name="myForm"]').val();
			
			sessionStorage.setItem('mortgageJSON', JSON.stringify(formsBIB.sessionMortgage));

			if (dataStepNew < 1) {
				var gotoform = "";
				var mortgageForm = sessionStorage.getItem('mortgageForm') || "";
				/*if (mortgageForm !== "") {
					mortgageForm = JSON.parse(mortgageForm);

					//if (myForm == 'form1') { gotoform = mortgageForm.form1 }
					if (myForm == 'form1') { gotoform = mortgageForm.landing }
					if (myForm == 'form2') { gotoform = mortgageForm.form1 }
					if (myForm == 'form3') { gotoform = mortgageForm.form2 }

					if (gotoform !== "") {
						sessionStorage.setItem('back', "true");
						window.location.href = gotoform;
					}
				}*/
				if (myForm !== 'form1') {
					sessionStorage.setItem('back', "true");
					window.location.replace($("#previous").attr("data-redirect-previous-step"));
				}
				else{
					var loanPage = sessionStorage.getItem('calc');
					if(loanPage == null || loanPage == undefined || loanPage == "" ){
						var loanLnkInside = window.location.pathname;
						if(loanLnkInside.includes("stanovnistvo")){
							loanPage = "/stanovnistvo";
						}
						else if(loanLnkInside.includes("magnifica")){
							loanPage = "/magnifica";
						}
					}
					window.location.replace(loanPage);
				}
				
				//history.back(1);
			} else {

				formsBIB.disableNext($('button.r-btn-next'));

				if (myForm == 'form1') {
					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {
							$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');
						} else {
							formsBIB.disableNext($('button.r-btn-next'));
						}
					}, 100);
				}

				if (myForm == 'form2') {

					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {
							var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2
							
							var stepNum = parseInt(formsBIB.getStep());
							var debitors_num = $(".rstepwrapper").eq(stepNum - 1).find('div[data-val]')[0];
							if(debitors_num && debitors_num != null && debitors_num != undefined){
								if(parseInt(debitors_num.innerText) >= 0){
									//formsBIB.setActiveNext($('button.r-btn-next'));
									var stepNextActive = formsBIB.getStep();
									formsBIB.setNextActiveCheckingFields(stepNextActive);
								}
							}

							// controllo sui radio per attivare il bottone
							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':checked')) {
									//formsBIB.setActiveNext($('button.r-btn-next'));
									var stepNextActive = formsBIB.getStep();
									formsBIB.setNextActiveCheckingFields(stepNextActive);
								}
							});

							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':visible')) {
									self.trigger("keyup");
								}
							});

						} else {
							//formsBIB.setActiveNext($('button.r-btn-next'));
							var stepNextActive = formsBIB.getStep();
							formsBIB.setNextActiveCheckingFields(stepNextActive);
						}
					}, 100);
				}
				
				if (myForm == 'form3') {
					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input:checked').length > 0) {
							$(".rstepwrapper").eq(dataStepNew - 1).find('input:checked').parent('.rcontainer-input').trigger('click');
						} else {
							formsBIB.disableNext($('button.r-btn-next'));
						}
					}, 100);
				}

				formsBIB.refreshStep(dataStepNew);
				formsBIB.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');

			}
			
			// formsBIB.checkMobileOrDesktopQuestionOne();

			formsBIB.scrollToTop();
			
			//formsBIB.writeInput();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
		});
	}

	this.formStep1Mortagage = function () {
		formsBIB.setStep(1);
	}

	//set active input
	this.setActiveInput = function () {
		$(".rcontainer-input").on("click", function () {
			var name = $(this).find('input').attr("name");
			$('[name=' + name + ']').parent().removeClass("active");
			$(this).addClass("active");

			var myForm = $('input[name="myForm"]').val();

			if (myForm == 'form1') {
				var stepNumber = parseInt(formsBIB.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				if (chekToInput) formsBIB.sessionMortgage[0].form1[name] = $('[name=' + name + ']:checked').val();
			}

			if (myForm == 'form2') {
				var stepNumber = parseInt(formsBIB.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsBIB.sessionMortgage[0].form2[name] = $('[name=' + name + ']:checked').val();
				if(name == "propertySubject"){
					if($("#propertySubject1").is(':checked')){
						formsBIB.sessionMortgage[0].form2["isFinancedPropertyCollateral"] = "Yes";
					}
					if($("#propertySubject2").is(':checked')){
						formsBIB.sessionMortgage[0].form2["isFinancedPropertyCollateral"] = "No";
					}
				}
			}

			if (myForm == 'form3') {
				var stepNumber = parseInt(formsBIB.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsBIB.sessionMortgage[0].form3[name] = $('[name=' + name + ']:checked').val();
			}

			
			var step = parseInt(formsBIB.getStep());
			formsBIB.setNextActiveCheckingFields(step);
			//formsBIB.showError(formsBIB.getStep());
		});

	}

	this.setActiveImport = function () {
		$(".rcontainer-import input").on("keyup", function () {
			var self = $(this);
			if (self.val().length > 0) {

				// if ((self.attr("name") == "babyLoan") || (self.attr("name") == "cashLoan")) {
				// 	if (($("[name=cashLoan]").val().length > 0) && ($("[name=babyLoan]").val().length > 0)) {
				// 		formsBIB.setActiveNext($('button.r-btn-next'));
				// 	} else {
				// 		formsBIB.disableNext($('button.r-btn-next'));
				// 	}
				// } 
				//formsBIB.setActiveNext($('button.r-btn-next'));
				var stepNextActive = formsBIB.getStep();
				formsBIB.setNextActiveCheckingFields(stepNextActive);


				if ($(".rstepwrapper").eq(parseInt(formsBIB.getStep()) - 1).find("input").length > 1 && $(".rstepwrapper").eq(parseInt(formsBIB.getStep()) - 1).find('.rcontainer-import').attr('data-showhideloan') == undefined) {
					$(".rstepwrapper").eq(parseInt(formsBIB.getStep()) - 1).find("input").each(function () {
						if ($(this).is(':visible') && $(this).val() == '') {
							formsBIB.disableNext($('button.r-btn-next'));
							return;
						}
					});
				}

				var name = $(this).attr("name");
				var myForm = $('input[name="myForm"]').val();

				if (myForm == 'form2') {
					// Potrebbe servirci da controllare all'invio della mail
					if (isCIB) {
						formsBIB.sessionMortgage[0].form2[name] = $('[name=' + name + ']').val().replace(/ /g, '');
					} else {

						if ($('[name=' + name + ']').attr('type') != "radio" && $('[name=' + name + ']').length > 1) {
							for (var i = 0; i < $('[name=' + name + ']').length; i++) {
								if ($($('[name=' + name + ']')[i]).val() != "") {
									formsBIB.sessionMortgage[0].form2[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
								}
							}
						} else {
							formsBIB.sessionMortgage[0].form2[name] = $('[name=' + name + ']').val().replace(/ /g, '');
						}
					}
				}

				if (myForm == 'form3') {
					if ($('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								formsBIB.sessionMortgage[0].form3[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						formsBIB.sessionMortgage[0].form3[name] = $('[name=' + name + ']').val().replace(/ /g, '');
					}
				}
			} else {
				formsBIB.disableNext($('button.r-btn-next'));
			}
		});
	}

	//refresh the step progress
	this.refreshStep = function (step) {
		var myForm = $('input[name="myForm"]').val();
		totalSteps = 8;

		if (myForm == 'form2') {
			step += 1;
		}

		if (myForm == 'form3') {
			if($('#debtorPresence2').is(":checked")){
				totalSteps = 7;
				$('#numberofsteps').attr("value", "2");
				formsBIB.sessionMortgage[0]["form3"]["codebtorCreditCardDebt"] = "";
				formsBIB.sessionMortgage[0]["form3"]["codebtorCreditCardPresence"] = "";
			}
			else{
				totalSteps = 8;
				$('#numberofsteps').attr("value", "3");
			}
			step += 5;
			if(step === totalSteps){
				var lastNextLabel = $("[name=lastQuestionMortgage]").attr("data-last-question");
				$("[name=lastQuestionMortgage]").html(lastNextLabel);
			}
			else{
				var notLastNextLabel = $("[name=lastQuestionMortgage]").attr("data-notlast-question");
				$("[name=lastQuestionMortgage]").html(notLastNextLabel);
			}
		}

		if ((step !== null) && (step !== "") && (step !== undefined)) {
			$(".r-cur-step").text(step);
			if ((totalSteps !== null) && (totalSteps !== "") && (totalSteps !== undefined)) {
				$(".r-tot-step").text(totalSteps);
				$(".r-progress-bar-fill").width(parseInt(step) / parseInt(totalSteps) * 100 + "%");
			}
		}
		formsBIB.scrollToTop();
	}

	//set button next active
	this.setActiveNext = function (thisBtn) {
		thisBtn.addClass("active").prop("disabled", false);
	}

	//disable button next
	this.disableNext = function (thisBtn) {
		thisBtn.removeClass("active").prop("disabled", true);
	}

	//get the current step number
	this.getStep = function () {
		var stepNumber = $('button.r-btn-next').attr('data-step');
		return stepNumber;
	}

	//show the error msg
	this.showError = function (stepNumber) {
		stepNumber = parseInt(stepNumber);
		var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked") || false;
		if (curstepwrapper || curstepwrapper == "true") {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").addClass('rhide'); //hide the error
			//formsBIB.setActiveNext($('button.r-btn-next'));
			var stepNextActive = formsBIB.getStep();
			formsBIB.setNextActiveCheckingFields(stepNextActive);
		} else {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").removeClass('rhide'); //show the error
			formsBIB.disableNext($('button.r-btn-next'));
		}

	}

	//set the current step number
	this.setStep = function (stepNumber) {
		$(".r-form-submit-wrapper button").attr("data-step", stepNumber);
		formsBIB.refreshStep(stepNumber);
	}

	//toggle form accordion
	this.toggleAccordion = function () {

		$('[data-accordion="title"]').on("click", function () {

			$(this).addClass("rhide");
			$(this).next('[data-accordion="detail"]').removeClass("rhide");

		});

		$('[data-accordion="detail"] .rtitle-accordotion').on("click", function () {

			$(this).parent().addClass("rhide");
			$(this).parent().prev('[data-accordion="title"]').removeClass("rhide");

		});

	}
	
	
	// DA VERIFICARE
	// controllo se collateral properties è almeno 1
	this.checkMinCollateral = function () {
		if($('#collateralProperties').is(':visible')){
			val = $('#collateralProperties').html();
			if (val != "0") {
				formsBIB.setActiveNext($('button.r-btn-next'));
			}
			else{
				formsBIB.disableNext($('button.r-btn-next'));
			}
		}
	}

	//plus minus
	this.plusMinus = function (val) {

		if ($("[data-plusminus]").length > 0) {

			$("[data-plusminus]").each(function (index, elem) {

				if ((val !== null) && (val !== undefined) && (val !== "")) {
					$(elem).find("[data-val]").text(val);
				}

				var thisMax = $(elem).attr("data-maximum");

				var curVal = $(elem).find("[data-val]").text();
				var thisMinus = $(elem).find("[data-minus]");
				var thisPlus = $(elem).find("[data-plus]");


				thisMinus.removeClass("disabled");
				thisPlus.removeClass("disabled");
				if (curVal == "0") {
					thisMinus.addClass("disabled");
				}

				if (curVal == thisMax) {
					thisPlus.addClass("disabled");
				}
				
				formsBIB.checkMinCollateral();		// DA VERIFICARE

			});
		}
	}

	
	this.setStartingPage = function () {
		
		var loanLnk;
		var previousPage = document.referrer;
		var thisPageLink = window.location.pathname;
		
		if(!previousPage.includes("stanovnistvo") && !previousPage.includes("magnifica")){
			if(thisPageLink.includes("stanovnistvo")){
				var defaultRetail = $("[name=linkDefaultRetailMortgage]").attr("data-mortgage-link-default-retail");
				loanLnk = defaultRetail;
			} else if(thisPageLink.includes("magnifica")){
				var defaultMagnifica = $("[name=linkDefaultMagnificaMortgage]").attr("data-mortgage-link-default-magnifica");
				loanLnk = defaultMagnifica;
			}
		}
		else {
			loanLnk = previousPage;
		}
		
		sessionStorage.setItem('calc', loanLnk);
		
	}
	

	//Open form mortgage
	$("[data-openmortgageform]").on("click", function () {

		formsBIB.getInputs();

		var calcLnk = window.location.pathname;
		sessionStorage.setItem('calc', calcLnk);
		
		window.location.replace($('[data-openmortgageform]').attr("data-mortgage-link"));

	});
	
	
	$(".loanLink").click(function () {
		var loanLnk = sessionStorage.getItem('calc');
		if(loanLnk == null || loanLnk == undefined || loanLnk == "" ){
			var loanLnkInside = window.location.pathname;
			if(loanLnkInside.includes("stanovnistvo")){
				loanLnk = "/stanovnistvo";
			}
			else if(loanLnkInside.includes("magnifica")){
				loanLnk = "/magnifica";
			}
		}
	    this['href'] = loanLnk;
	})

	//get inputs for the form
	this.getInputs = function () {

		var tenor = "" + window.intesa.loan_calculator_bib.tenor || "";
		var tenorUnit = "" + window.intesa.loan_calculator_bib.tenorUnit || "";
		var loanAmount = "" + window.intesa.loan_calculator_bib.loanAmount || "";
		var interestRate = "" + window.intesa.loan_calculator_bib.interestRateType || "";
		var firstInterestRate = "" + window.intesa.loan_calculator_bib.firstInterestRate || "";
		var installment = "" + window.intesa.loan_calculator_bib.firstMonthlyInstallment || "";
		var currency = "" + window.intesa.loan_calculator_bib.currency || "";
		
		var salaryButtons = $(".salary_buttons").find(':radio:checked').attr("id") || "";
		var mass_uppermass = "";
		if(salaryButtons !== ""){
			if(salaryButtons === "salaryButtons2"){
				mass_uppermass = "uppermass";
			}
			else{
				mass_uppermass = "mass";
			}
		}
		
		var fee = $("[data-algorithm-output=fee]:visible").html().replaceAll("&nbsp;"," ") || "";
		var amountToRepay = $("[data-algorithm-output=amountToRepay]:visible").html().replaceAll("&nbsp;"," ") || "";
		var loanAmountWithoutPartecipation = $("[data-algorithm-output=loanAmount]:visible").html().replaceAll("&nbsp;"," ") || "";
		if(loanAmountWithoutPartecipation == ""){
			loanAmountWithoutPartecipation = loanAmount;
		}
		
		var loanLink = window.location.pathname;
		var isMagnifica = "false";
		if(loanLink.includes("magnifica")){
			isMagnifica = "true";
		}
		
		var productName = $("[name=fProductName]").val() || "";
		var productId = $("[name=fProductId]").val() || "";
		// var interestPeriod = $("[name=fInterestPeriod]").val() || "";
		// var loanPurpose = $("[name=fLoanPurpose]").val() || "";
		// var personalLoanConfiguration = JSON.parse($("[name=personalLoanConfiguration]").val()) || "";


		formsBIB.sessionMortgage[0].form1.loanAmount = loanAmount || '';
		formsBIB.sessionMortgage[0].form1.tenor = tenor || '';
		formsBIB.sessionMortgage[0].form1.interestRate = interestRate || '';
		formsBIB.sessionMortgage[0].form1.installment = installment || '';
		formsBIB.sessionMortgage[0].form1.amountToRepay = amountToRepay || '';
		formsBIB.sessionMortgage[0].form1.currency = currency || '';
		formsBIB.sessionMortgage[0].form1.firstInterestRate = firstInterestRate || '';
		formsBIB.sessionMortgage[0].form1.tenorUnit = tenorUnit || '';
		
		formsBIB.sessionMortgage[0].form1.fee = fee || '';
		formsBIB.sessionMortgage[0].form1.loanAmountWithoutPartecipation = loanAmountWithoutPartecipation || '';
		
		formsBIB.sessionMortgage[0].form1.productIdOld = productId || '';
		formsBIB.sessionMortgage[0].form1.productNameOld = productName || '';
		// formsBIB.sessionMortgage[0].form1.interestPeriod = interestPeriod || '';
		// formsBIB.sessionMortgage[0].form1.loanPurpose = loanPurpose || '';
		// formsBIB.sessionMortgage[0].form1.personalLoanConfiguration = personalLoanConfiguration || '';
		
		formsBIB.sessionMortgage[0].summary.mass_uppermass = mass_uppermass || '';
		formsBIB.sessionMortgage[0].summary.isMagnifica = isMagnifica || '';

		sessionStorage.setItem('mortgageJSON', JSON.stringify(formsBIB.sessionMortgage));
		
		sessionStorage.setItem('isMagnificaSegment', isMagnifica);


	}

	//show hide elements
	this.showHideElements = function (val) {

		if ((val !== null) && (val !== undefined) && (val !== "")) {

			var stepNumber = formsBIB.getStep();
			var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1);
			curstepwrapper.find(".mod-hom1").addClass("rhide");
			val = parseInt(val);

			for (i = 0; i <= val - 1; i++) {
				curstepwrapper.find(".mod-hom1").eq(i).removeClass("rhide");
			}

			if (val > 0) {
				//formsBIB.setActiveNext($('button.r-btn-next'));
				var stepNextActive = formsBIB.getStep();
				formsBIB.setNextActiveCheckingFields(stepNextActive);
			}
			if ($(".rstepwrapper").eq(parseInt(formsBIB.getStep()) - 1).find("input").length > 1) {
				$(".rstepwrapper").eq(parseInt(formsBIB.getStep()) - 1).find("input").each(function () {
					if (($(this).is(':visible') && $(this).val() == '')) {

						if (!isCIB && formsBIB.getStep() == 2) {
							//formsBIB.setActiveNext($('button.r-bth-next'));
							var stepNextActive = formsBIB.getStep();
							formsBIB.setNextActiveCheckingFields(stepNextActive);
						}
						formsBIB.disableNext($('button.r-btn-next'));
						return;
					}
				});
			}
		}

	}

	/*this.resetForms2 = function (thisVal) {
		if (parseInt(thisVal) - 1 == 0) {
			$('input[name="debitorIncomeOne"]').val('');
			formsBIB.sessionMortgage[0].form2.debitorIncomeOne = "";
		}
		if (parseInt(thisVal) - 1 == 1) {
			$('input[name="debitorIncomeTwo"]').val('');
			formsBIB.sessionMortgage[0].form2.debitorIncomeTwo = "";
		}
	}*/

	//decrease Value
	$("[data-minus]").on("click", function () {
		var thisCounter = $(this).next("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) - 1);
			var nameVariable = $("[data-val]:visible").attr("name");
			formsBIB.sessionMortgage[0].form2[nameVariable] = String(parseInt(thisVal) - 1);
			formsBIB.plusMinus();

			//formsBIB.showHideElements(parseInt(thisVal) - 1);

			/*if ($('input[name="debitorIncomeOne"]').length > 0) {
				formsBIB.resetForms2(thisVal);
			}*/
		}
		
		var step = parseInt(formsBIB.getStep());
		formsBIB.setNextActiveCheckingFields(step);
	});


	var elem = $('.rcontainer-import')
	//show/hide loan form2
	$("[data-showloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").removeClass("rhide");
		
		if($("[data-val]:visible").length > 0){
			var nameVariable = $("[data-val]:visible").attr("name");
			var value = formsBIB.sessionMortgage[0].form2[nameVariable];
			$("[data-val]:visible").html(value);
			if(value === "0"){
				$("[data-minus]:visible").addClass("disabled");
			}
		}
		
		var step = parseInt(formsBIB.getStep());
		formsBIB.setNextActiveCheckingFields(step);
	});
	$("[data-showloan-second]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan-second]").removeClass("rhide");
		
		if($("[data-val]:visible").length > 0){
			var nameVariable = $("[data-val]:visible").attr("name");
			var value = formsBIB.sessionMortgage[0].form2[nameVariable];
			$("[data-val]:visible").html(value);
			if(value === "0"){
				$("[data-minus]:visible").addClass("disabled");
			}
		}
		
		var step = parseInt(formsBIB.getStep());
		formsBIB.setNextActiveCheckingFields(step);
	});
	$("[data-hideloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").addClass("rhide").find("input"); //.val("")
		if (myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON') || "")[0].form2;
		}
		
		var step = parseInt(formsBIB.getStep());
		formsBIB.setNextActiveCheckingFields(step);
	});
	$("[data-hideloan-second]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan-second]").addClass("rhide").find("input"); //.val("")
		if (myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON') || "")[0].form2;
		}
		
		var step = parseInt(formsBIB.getStep());
		formsBIB.setNextActiveCheckingFields(step);
	});

	//increase Value
	$("[data-plus]").on("click", function () {

		var thisCounter = $(this).prev("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) + 1);
			var nameVariable = $("[data-val]:visible").attr("name");
			formsBIB.sessionMortgage[0].form2[nameVariable] = String(parseInt(thisVal) + 1);
			
			formsBIB.plusMinus();

			//formsBIB.showHideElements(parseInt(thisVal) + 1);

			if (isCIB) {
				if (parseInt(thisVal) + 1 == 1) {
					$('input[name="debitorIncomeOne"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 2) {
					$('input[name="debitorIncomeTwo"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 3) {
					$('input[name="debitorIncomeThree"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 4) {
					$('input[name="debitorIncomeFour"]').trigger('keyup');
				}
			}
		}
		
		var step = parseInt(formsBIB.getStep());
		formsBIB.setNextActiveCheckingFields(step);
	});

	//set selected label as active
	$(".r-thankyou-time label").on("click", function () {
		$(".r-thankyou-time label").removeClass("active");
		$(this).addClass("active");
	});

	//accept only numbers
	$(document).on("input", ".r-thankyou-wrapper [name='prefixNumber'], .r-thankyou-wrapper [name='phoneNumber']", function (e) {
		$(this).val($(this).val().replace(/[^0-9]/g, ''));//allow only numbers
	});

	//check success form privacy status
	this.checkPrivacy = function () {
		var item_thanksName = "none";
		if ($("#item_thanksName").length > 0) {
			item_thanksName = $("#item_thanksName").val();
		}
		var thanksLastname = "none";
		if ($("#item_thanksLastname").length > 0) {
			thanksLastname = $("#item_thanksLastname").val();
		}
		var checkCaptcha = $("input[name='recaptchaKey']").length >= 1 || "" != $(".g-recaptcha-response").val() ? true : false;
		const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		const reName = /^[a-zA-ZÁÉÚŰŐÓÜÖÍáéúűőóüöíčćšžđČĆŠŽĐ \- \\s.]*$/;
		if (($("#privacystatus").is(":checked")) && ($("#item_email").val() !== "") && (re.test($("#item_email").val())) 
				&& (item_thanksName !== "") && (thanksLastname !== "") && (reName.test(item_thanksName)) && (reName.test(thanksLastname))
			&& ($('[name="prefixNumber"]').val() !== "") && ($('[name="phoneNumber"]').val() !== "") && ($('[name="phoneNumber"]:visible').parsley().validate()==true)
			&& (checkCaptcha) && ($("#selectedCity").val() !== "")) {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", false);
		} else {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", true);
		}
	}


	//change btn status after privacy changes
	$("#privacystatus").on("click", function () {

		formsBIB.checkPrivacy();

	});
	
	$("#selectedCity").on("change input", function (e) {
		formsBIB.checkPrivacy();
	});

	$(".r-thankyou-wrapper input").on("change input", function (e) {
		formsBIB.checkPrivacy();
	});

	//validate on focus out
	$('.r-thankyou-content input[required]').on("focusout blur", function () {
		$(this).parsley().validate();
	});


	//submit form success
	$(".r-thankyou-wrapper .j-privacy__btn").on("click", function (e) {

		e.preventDefault();

		//check parsley first
		var isformok = $('form[name="formThanksMortgage"]').parsley().validate();
		if (isformok) {

			// get all the inputs into an array.
			var $inputs = $('.r-thankyou-content :input');

			$inputs.each(function () {

				if ($(this).attr('name') !== undefined) {

					var vall = $(this).val() || "";
					var namee = $(this).attr('name') || "";

					if (namee == "privacystatus") {
						if ($(this).is(":checked")) {
							vall = "true";
						} else {
							vall = "false";
						}
					}

					if (namee == "radioTime") {
						if ($(this).is(":checked")) {
							$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
							$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
						} else {
							//
						}
						//
					} else {
						$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
						$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
					}

				}


			});
			
			var sessionStorageMortage = sessionStorage.getItem('mortgageJSON') || "";
			if (sessionStorageMortage !== "") {
				if (sessionStorageMortage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortage);
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if (JSON_Obj[0].form1[key].length > 0 && key != "personalLoanConfiguration" ) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						if(key != "personalLoanConfiguration"){
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if(JSON_Obj[0].form1.personalLoanConfiguration != undefined){
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="personalLoanConfiguration" value=""/>');
					$('form[name="formThanksMortgage"] input[name="personalLoanConfiguration"]').val(JSON.stringify(JSON_Obj[0].form1.personalLoanConfiguration).toString());
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if (JSON_Obj[0].form2[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if (JSON_Obj[0].form3[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].summary) {
				for (var key in JSON_Obj[0].summary) {
					if (JSON_Obj[0].summary[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].summary[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].score) {
				var scoreSum = JSON_Obj[0].score;
				var priority = scoreSum;
				
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="priorityMortgage" value="' + priority + '"/>');
			}
			
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].typeOfAppointment) {
				var typeOfAppointment = JSON_Obj[0].typeOfAppointment;
				
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="typeOfAppointment" value="' + typeOfAppointment + '"/>');
			}
			
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].summary && JSON_Obj[0].summary.isMagnifica) {
				var customerType = "";
				if(JSON_Obj[0].summary.isMagnifica == "true"){
					customerType =  $("[name=emailSubjectCustomerType]").attr("data-mortgage-magnifica-customer-email-placeholder");
				}
				else{
					customerType =  $("[name=emailSubjectCustomerType]").attr("data-mortgage-intesacasa-customer-email-placeholder");
				}
				
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="customerType" value="' + customerType + '"/>');
			}
			
			
			// var linkThisPage = window.location.href;
			
			// $('form[name="formThanksMortgage"]').append('<input type="hidden" name="sourceUrl" value="' + linkThisPage + '"/>');
			
			$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary')[0].innerHTML = '<span><img alt = "" aria-hidden = "true" class="loading-mortgage" width="22" height="22"></img></span>';
			$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
			$('form[name="formThanksMortgage"]').submit();

		}
		
		//window.location.replace($("#submitMortgage").attr("data-redirect"));

		return false;


	});

	//delete sessionstorage if form is successfully sent
	if ($("[data-formsent]").length > 0) {
		sessionStorage.removeItem('mortgageJSON');
		sessionStorage.removeItem('mortgageStep');
	}

	//on resize, reset the wallpaper
	function resizedw() {
		if ($("[data-bgimg]").length > 0) {
			$("[data-bgimg]").each(function () {
				var imageUrl = $(this).attr("data-bgimg");
				$(this).css('background-image', 'url(' + imageUrl + ')');
			});
		}
	}

	var doit;
	window.onresize = function () {
		clearTimeout(doit);
		doit = setTimeout(resizedw, 10);
	};

	//replace placeholder in mortgage title
	var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON') || "";
	if (sessionStorageMortgage.length > 0) {
		var JSON_Obj = JSON.parse(sessionStorageMortgage);
		var placeholder = JSON_Obj[0].form1["productName"] || "";
		if ($(".r-title").length > 0) {
			$(".r-title").each(function () {
				var thistitle = $(this).html();
				thistitle = thistitle.replace("${productName}", placeholder);
				$(this).html(thistitle);
			})
		}
	}

	/**
	 * Call to servlet
	 *
	 * @param {*} url
	 * @param {*} form
	 */
	this.callServlet = function (url, form) {

		$.ajax({

			type: "POST",
			data: form.serialize(),
			url: url,
			success: function (data) {

				console.log("success sending form");

			},
			error: function (data) {

				console.log("error sending form");

			}

		});

	};


	/**
	 * Show modal
	 *
	 */
	/*
	this.showModal = function () {

		if ($("[data-show-modal]").length) {

			$("[data-show-modal]").each(function (index, el) {

				if ($(this).attr("data-show-modal") == "true") {

					var modalName = $(this).attr("id");
					$("[data-target='#" + modalName + "']").trigger('click');

				}

			});

		}

	};
	*/
	
	$(document).ready(function() {
		var check = $("#landing-button-mortgage").length > 0;
		if (check){
		    setTimeout(function() {
		    $("#landing-button-mortgage").removeClass("disabled");
		    },1000);
		    
		    $('#landing-button-mortgage').on('click',function(e){
	        	$('#landing-button-mortgage')[0].innerHTML = '<span><img alt = "" aria-hidden = "true" class="loading-mortgage" width="22" height="22"></img></span>';
	        	$('#landing-button-mortgage')[0].disabled = true;
		    });
		    
		}
		
	});

};



/**
 * Get class instance
 *
 */
Intesa.FormsBIB.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.formsBIB) {

		window.intesa.formsBIB = new Intesa.FormsBIB();

	}

	return window.intesa.formsBIB;

};
      /**
* On DOM ready
*
*/
      // $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {
 
	// init component
	var formsBIB = Intesa.formsBIB.getInstance();
	formsBIB.init();
 
} ); */
